/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/

import * as thrift from "thrift";
import { Int64 } from "thrift";
import * as PContact from "./../../../common/models";
import * as ElkEvent from "./../../events/messages";
import * as ContactLite from "./../../../contactlite/messages";
export enum TAppPhoenixLocationPermission {
    ALWAYS = 0,
    WHILE_USING = 1,
    ASK_NEXT_TIME = 2,
    NEVER = 3
}
export enum TAppPhoenixCameraRollPermission {
    ALL = 0,
    SELECTED_PHOTOS = 1,
    NONE = 2
}
export enum TAppPhoenixPhotoExclusionReason {
    UNDEFINED = 0,
    NO_FACES = 1,
    AWAY_FROM_EVENT = 2,
    OUTSIDE_OF_TIME_WINDOW = 3,
    SENSITIVE_CONTENT = 4,
    INDIVIDUAL_SELFIE = 5,
    SUGGESTED_UPLOAD = 6,
    NO_PHOTO_LOCATION = 7
}
export enum TAppPhoenixPhotoUploadMode {
    UNDEFINED = 0,
    AUTOMATIC = 1,
    MANUAL = 2
}
export enum TAppPhoenixAlbumType {
    EVENT = 0,
    GROUP = 1
}
export enum TAlbumShareSuggestionPlacement {
    HOME_FEED_VIEW = 0,
    ALBUM_VIEW = 1,
    FOR_YOUR = 2
}
export enum TAppPhoenixAlbumSuggestionStatus {
    PENDING = 0,
    ACCEPTED = 1,
    REJECTED = 2
}
export enum TAppOnDeviceTaskType {
    PHASH = 0,
    FEATURE_PRINT_V1 = 1,
    FEATURE_PRINT_V2 = 2,
    FACE_COUNT = 3,
    OCR = 4,
    LAPLACIAN_VARIANCE = 5
}
export interface ITAppPhoenixUserArgs {
    userId: string;
    name: string;
    photoUrl?: string;
    grantedLocationPermission?: TAppPhoenixLocationPermission;
    grantedNotificationPermission?: boolean;
    grantedContactPermission?: boolean;
    grantedCameraRollPermission?: TAppPhoenixCameraRollPermission;
    homeAddress?: PContact.TAppAddress;
    workAddress?: PContact.TAppAddress;
    defaultUploadMode?: TAppPhoenixPhotoUploadMode;
}
export class TAppPhoenixUser {
    public userId: string;
    public name: string;
    public photoUrl?: string;
    public grantedLocationPermission?: TAppPhoenixLocationPermission;
    public grantedNotificationPermission?: boolean;
    public grantedContactPermission?: boolean;
    public grantedCameraRollPermission?: TAppPhoenixCameraRollPermission;
    public homeAddress?: PContact.TAppAddress;
    public workAddress?: PContact.TAppAddress;
    public defaultUploadMode?: TAppPhoenixPhotoUploadMode;
    constructor(args: ITAppPhoenixUserArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.name != null) {
            this.name = args.name;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[name] is unset!");
        }
        if (args != null && args.photoUrl != null) {
            this.photoUrl = args.photoUrl;
        }
        if (args != null && args.grantedLocationPermission != null) {
            this.grantedLocationPermission = args.grantedLocationPermission;
        }
        if (args != null && args.grantedNotificationPermission != null) {
            this.grantedNotificationPermission = args.grantedNotificationPermission;
        }
        if (args != null && args.grantedContactPermission != null) {
            this.grantedContactPermission = args.grantedContactPermission;
        }
        if (args != null && args.grantedCameraRollPermission != null) {
            this.grantedCameraRollPermission = args.grantedCameraRollPermission;
        }
        if (args != null && args.homeAddress != null) {
            this.homeAddress = args.homeAddress;
        }
        if (args != null && args.workAddress != null) {
            this.workAddress = args.workAddress;
        }
        if (args != null && args.defaultUploadMode != null) {
            this.defaultUploadMode = args.defaultUploadMode;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixUser");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.name != null) {
            output.writeFieldBegin("name", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.name);
            output.writeFieldEnd();
        }
        if (this.photoUrl != null) {
            output.writeFieldBegin("photoUrl", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.photoUrl);
            output.writeFieldEnd();
        }
        if (this.grantedLocationPermission != null) {
            output.writeFieldBegin("grantedLocationPermission", thrift.Thrift.Type.I32, 8);
            output.writeI32(this.grantedLocationPermission);
            output.writeFieldEnd();
        }
        if (this.grantedNotificationPermission != null) {
            output.writeFieldBegin("grantedNotificationPermission", thrift.Thrift.Type.BOOL, 9);
            output.writeBool(this.grantedNotificationPermission);
            output.writeFieldEnd();
        }
        if (this.grantedContactPermission != null) {
            output.writeFieldBegin("grantedContactPermission", thrift.Thrift.Type.BOOL, 10);
            output.writeBool(this.grantedContactPermission);
            output.writeFieldEnd();
        }
        if (this.grantedCameraRollPermission != null) {
            output.writeFieldBegin("grantedCameraRollPermission", thrift.Thrift.Type.I32, 11);
            output.writeI32(this.grantedCameraRollPermission);
            output.writeFieldEnd();
        }
        if (this.homeAddress != null) {
            output.writeFieldBegin("homeAddress", thrift.Thrift.Type.STRUCT, 12);
            this.homeAddress.write(output);
            output.writeFieldEnd();
        }
        if (this.workAddress != null) {
            output.writeFieldBegin("workAddress", thrift.Thrift.Type.STRUCT, 13);
            this.workAddress.write(output);
            output.writeFieldEnd();
        }
        if (this.defaultUploadMode != null) {
            output.writeFieldBegin("defaultUploadMode", thrift.Thrift.Type.I32, 14);
            output.writeI32(this.defaultUploadMode);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixUser {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_1: string = input.readString();
                        _args.userId = value_1;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_2: string = input.readString();
                        _args.name = value_2;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_3: string = input.readString();
                        _args.photoUrl = value_3;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_4: TAppPhoenixLocationPermission = input.readI32();
                        _args.grantedLocationPermission = value_4;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_5: boolean = input.readBool();
                        _args.grantedNotificationPermission = value_5;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_6: boolean = input.readBool();
                        _args.grantedContactPermission = value_6;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_7: TAppPhoenixCameraRollPermission = input.readI32();
                        _args.grantedCameraRollPermission = value_7;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_8: PContact.TAppAddress = PContact.TAppAddress.read(input);
                        _args.homeAddress = value_8;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 13:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_9: PContact.TAppAddress = PContact.TAppAddress.read(input);
                        _args.workAddress = value_9;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 14:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_10: TAppPhoenixPhotoUploadMode = input.readI32();
                        _args.defaultUploadMode = value_10;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.name !== undefined) {
            return new TAppPhoenixUser(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixUser from input");
        }
    }
}
export interface ITAppPhoenixCoordinateLocationArgs {
    longitude?: number;
    latitude?: number;
    altitude?: number;
    horizontalAccuracy?: number;
    verticalAccuracy?: number;
}
export class TAppPhoenixCoordinateLocation {
    public longitude?: number;
    public latitude?: number;
    public altitude?: number;
    public horizontalAccuracy?: number;
    public verticalAccuracy?: number;
    constructor(args?: ITAppPhoenixCoordinateLocationArgs) {
        if (args != null && args.longitude != null) {
            this.longitude = args.longitude;
        }
        if (args != null && args.latitude != null) {
            this.latitude = args.latitude;
        }
        if (args != null && args.altitude != null) {
            this.altitude = args.altitude;
        }
        if (args != null && args.horizontalAccuracy != null) {
            this.horizontalAccuracy = args.horizontalAccuracy;
        }
        if (args != null && args.verticalAccuracy != null) {
            this.verticalAccuracy = args.verticalAccuracy;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixCoordinateLocation");
        if (this.longitude != null) {
            output.writeFieldBegin("longitude", thrift.Thrift.Type.DOUBLE, 1);
            output.writeDouble(this.longitude);
            output.writeFieldEnd();
        }
        if (this.latitude != null) {
            output.writeFieldBegin("latitude", thrift.Thrift.Type.DOUBLE, 2);
            output.writeDouble(this.latitude);
            output.writeFieldEnd();
        }
        if (this.altitude != null) {
            output.writeFieldBegin("altitude", thrift.Thrift.Type.DOUBLE, 3);
            output.writeDouble(this.altitude);
            output.writeFieldEnd();
        }
        if (this.horizontalAccuracy != null) {
            output.writeFieldBegin("horizontalAccuracy", thrift.Thrift.Type.DOUBLE, 4);
            output.writeDouble(this.horizontalAccuracy);
            output.writeFieldEnd();
        }
        if (this.verticalAccuracy != null) {
            output.writeFieldBegin("verticalAccuracy", thrift.Thrift.Type.DOUBLE, 5);
            output.writeDouble(this.verticalAccuracy);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixCoordinateLocation {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_11: number = input.readDouble();
                        _args.longitude = value_11;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_12: number = input.readDouble();
                        _args.latitude = value_12;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_13: number = input.readDouble();
                        _args.altitude = value_13;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_14: number = input.readDouble();
                        _args.horizontalAccuracy = value_14;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_15: number = input.readDouble();
                        _args.verticalAccuracy = value_15;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppPhoenixCoordinateLocation(_args);
    }
}
export interface ITAppPhoenixAlbumMetaArgs {
    title?: string;
    startTs?: number | Int64;
    endTs?: number | Int64;
    location?: TAppPhoenixCoordinateLocation;
    albumId?: string;
    albumCode?: string;
    ownerUserId?: string;
    addressInfo?: PContact.TAppAddress;
    albumCoverPhotoId?: string;
    elkEventMeta?: ElkEvent.TAppElkPhoenixEvent;
    timezone?: string;
    albumType?: TAppPhoenixAlbumType;
    lastActivityTs?: number | Int64;
    reactions?: Array<TAppPhoenixReaction>;
    albumCoverUrl?: string;
    comments?: Array<TAppPhoenixComment>;
}
export class TAppPhoenixAlbumMeta {
    public title?: string;
    public startTs?: Int64;
    public endTs?: Int64;
    public location?: TAppPhoenixCoordinateLocation;
    public albumId?: string;
    public albumCode?: string;
    public ownerUserId?: string;
    public addressInfo?: PContact.TAppAddress;
    public albumCoverPhotoId?: string;
    public elkEventMeta?: ElkEvent.TAppElkPhoenixEvent;
    public timezone?: string;
    public albumType?: TAppPhoenixAlbumType;
    public lastActivityTs?: Int64;
    public reactions?: Array<TAppPhoenixReaction>;
    public albumCoverUrl?: string;
    public comments?: Array<TAppPhoenixComment>;
    constructor(args?: ITAppPhoenixAlbumMetaArgs) {
        if (args != null && args.title != null) {
            this.title = args.title;
        }
        if (args != null && args.startTs != null) {
            if (typeof args.startTs === "number") {
                this.startTs = new Int64(args.startTs);
            }
            else {
                this.startTs = args.startTs;
            }
        }
        if (args != null && args.endTs != null) {
            if (typeof args.endTs === "number") {
                this.endTs = new Int64(args.endTs);
            }
            else {
                this.endTs = args.endTs;
            }
        }
        if (args != null && args.location != null) {
            this.location = args.location;
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        if (args != null && args.albumCode != null) {
            this.albumCode = args.albumCode;
        }
        if (args != null && args.ownerUserId != null) {
            this.ownerUserId = args.ownerUserId;
        }
        if (args != null && args.addressInfo != null) {
            this.addressInfo = args.addressInfo;
        }
        if (args != null && args.albumCoverPhotoId != null) {
            this.albumCoverPhotoId = args.albumCoverPhotoId;
        }
        if (args != null && args.elkEventMeta != null) {
            this.elkEventMeta = args.elkEventMeta;
        }
        if (args != null && args.timezone != null) {
            this.timezone = args.timezone;
        }
        if (args != null && args.albumType != null) {
            this.albumType = args.albumType;
        }
        if (args != null && args.lastActivityTs != null) {
            if (typeof args.lastActivityTs === "number") {
                this.lastActivityTs = new Int64(args.lastActivityTs);
            }
            else {
                this.lastActivityTs = args.lastActivityTs;
            }
        }
        if (args != null && args.reactions != null) {
            this.reactions = args.reactions;
        }
        if (args != null && args.albumCoverUrl != null) {
            this.albumCoverUrl = args.albumCoverUrl;
        }
        if (args != null && args.comments != null) {
            this.comments = args.comments;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixAlbumMeta");
        if (this.title != null) {
            output.writeFieldBegin("title", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.title);
            output.writeFieldEnd();
        }
        if (this.startTs != null) {
            output.writeFieldBegin("startTs", thrift.Thrift.Type.I64, 2);
            output.writeI64(this.startTs);
            output.writeFieldEnd();
        }
        if (this.endTs != null) {
            output.writeFieldBegin("endTs", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.endTs);
            output.writeFieldEnd();
        }
        if (this.location != null) {
            output.writeFieldBegin("location", thrift.Thrift.Type.STRUCT, 4);
            this.location.write(output);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.albumCode != null) {
            output.writeFieldBegin("albumCode", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.albumCode);
            output.writeFieldEnd();
        }
        if (this.ownerUserId != null) {
            output.writeFieldBegin("ownerUserId", thrift.Thrift.Type.STRING, 7);
            output.writeString(this.ownerUserId);
            output.writeFieldEnd();
        }
        if (this.addressInfo != null) {
            output.writeFieldBegin("addressInfo", thrift.Thrift.Type.STRUCT, 8);
            this.addressInfo.write(output);
            output.writeFieldEnd();
        }
        if (this.albumCoverPhotoId != null) {
            output.writeFieldBegin("albumCoverPhotoId", thrift.Thrift.Type.STRING, 12);
            output.writeString(this.albumCoverPhotoId);
            output.writeFieldEnd();
        }
        if (this.elkEventMeta != null) {
            output.writeFieldBegin("elkEventMeta", thrift.Thrift.Type.STRUCT, 13);
            this.elkEventMeta.write(output);
            output.writeFieldEnd();
        }
        if (this.timezone != null) {
            output.writeFieldBegin("timezone", thrift.Thrift.Type.STRING, 14);
            output.writeString(this.timezone);
            output.writeFieldEnd();
        }
        if (this.albumType != null) {
            output.writeFieldBegin("albumType", thrift.Thrift.Type.I32, 15);
            output.writeI32(this.albumType);
            output.writeFieldEnd();
        }
        if (this.lastActivityTs != null) {
            output.writeFieldBegin("lastActivityTs", thrift.Thrift.Type.I64, 16);
            output.writeI64(this.lastActivityTs);
            output.writeFieldEnd();
        }
        if (this.reactions != null) {
            output.writeFieldBegin("reactions", thrift.Thrift.Type.LIST, 9);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.reactions.length);
            this.reactions.forEach((value_16: TAppPhoenixReaction): void => {
                value_16.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.albumCoverUrl != null) {
            output.writeFieldBegin("albumCoverUrl", thrift.Thrift.Type.STRING, 10);
            output.writeString(this.albumCoverUrl);
            output.writeFieldEnd();
        }
        if (this.comments != null) {
            output.writeFieldBegin("comments", thrift.Thrift.Type.LIST, 11);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.comments.length);
            this.comments.forEach((value_17: TAppPhoenixComment): void => {
                value_17.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixAlbumMeta {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_18: string = input.readString();
                        _args.title = value_18;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_19: Int64 = input.readI64();
                        _args.startTs = value_19;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_20: Int64 = input.readI64();
                        _args.endTs = value_20;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_21: TAppPhoenixCoordinateLocation = TAppPhoenixCoordinateLocation.read(input);
                        _args.location = value_21;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_22: string = input.readString();
                        _args.albumId = value_22;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_23: string = input.readString();
                        _args.albumCode = value_23;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_24: string = input.readString();
                        _args.ownerUserId = value_24;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_25: PContact.TAppAddress = PContact.TAppAddress.read(input);
                        _args.addressInfo = value_25;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_26: string = input.readString();
                        _args.albumCoverPhotoId = value_26;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 13:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_27: ElkEvent.TAppElkPhoenixEvent = ElkEvent.TAppElkPhoenixEvent.read(input);
                        _args.elkEventMeta = value_27;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 14:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_28: string = input.readString();
                        _args.timezone = value_28;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 15:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_29: TAppPhoenixAlbumType = input.readI32();
                        _args.albumType = value_29;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 16:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_30: Int64 = input.readI64();
                        _args.lastActivityTs = value_30;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_31: Array<TAppPhoenixReaction> = new Array<TAppPhoenixReaction>();
                        const metadata_1: thrift.TList = input.readListBegin();
                        const size_1: number = metadata_1.size;
                        for (let i_1: number = 0; i_1 < size_1; i_1++) {
                            const value_32: TAppPhoenixReaction = TAppPhoenixReaction.read(input);
                            value_31.push(value_32);
                        }
                        input.readListEnd();
                        _args.reactions = value_31;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_33: string = input.readString();
                        _args.albumCoverUrl = value_33;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_34: Array<TAppPhoenixComment> = new Array<TAppPhoenixComment>();
                        const metadata_2: thrift.TList = input.readListBegin();
                        const size_2: number = metadata_2.size;
                        for (let i_2: number = 0; i_2 < size_2; i_2++) {
                            const value_35: TAppPhoenixComment = TAppPhoenixComment.read(input);
                            value_34.push(value_35);
                        }
                        input.readListEnd();
                        _args.comments = value_34;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppPhoenixAlbumMeta(_args);
    }
}
export interface ITAppPhoenixFaceBoundingBoxArgs {
    left: number;
    top: number;
    height: number;
    width: number;
}
export class TAppPhoenixFaceBoundingBox {
    public left: number;
    public top: number;
    public height: number;
    public width: number;
    constructor(args: ITAppPhoenixFaceBoundingBoxArgs) {
        if (args != null && args.left != null) {
            this.left = args.left;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[left] is unset!");
        }
        if (args != null && args.top != null) {
            this.top = args.top;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[top] is unset!");
        }
        if (args != null && args.height != null) {
            this.height = args.height;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[height] is unset!");
        }
        if (args != null && args.width != null) {
            this.width = args.width;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[width] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixFaceBoundingBox");
        if (this.left != null) {
            output.writeFieldBegin("left", thrift.Thrift.Type.DOUBLE, 1);
            output.writeDouble(this.left);
            output.writeFieldEnd();
        }
        if (this.top != null) {
            output.writeFieldBegin("top", thrift.Thrift.Type.DOUBLE, 2);
            output.writeDouble(this.top);
            output.writeFieldEnd();
        }
        if (this.height != null) {
            output.writeFieldBegin("height", thrift.Thrift.Type.DOUBLE, 3);
            output.writeDouble(this.height);
            output.writeFieldEnd();
        }
        if (this.width != null) {
            output.writeFieldBegin("width", thrift.Thrift.Type.DOUBLE, 4);
            output.writeDouble(this.width);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixFaceBoundingBox {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_36: number = input.readDouble();
                        _args.left = value_36;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_37: number = input.readDouble();
                        _args.top = value_37;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_38: number = input.readDouble();
                        _args.height = value_38;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_39: number = input.readDouble();
                        _args.width = value_39;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.left !== undefined && _args.top !== undefined && _args.height !== undefined && _args.width !== undefined) {
            return new TAppPhoenixFaceBoundingBox(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixFaceBoundingBox from input");
        }
    }
}
export interface ITAppPhoenixAlbumFaceArgs {
    photoUrl: string;
    boundingBox: TAppPhoenixFaceBoundingBox;
    displayName?: string;
    contactId?: string;
    userId?: string;
    faceId: number | Int64;
    localFaceId: string;
    notSure: boolean;
    nameOnly: boolean;
}
export class TAppPhoenixAlbumFace {
    public photoUrl: string;
    public boundingBox: TAppPhoenixFaceBoundingBox;
    public displayName?: string;
    public contactId?: string;
    public userId?: string;
    public faceId: Int64;
    public localFaceId: string;
    public notSure: boolean = false;
    public nameOnly: boolean = false;
    constructor(args: ITAppPhoenixAlbumFaceArgs) {
        if (args != null && args.photoUrl != null) {
            this.photoUrl = args.photoUrl;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoUrl] is unset!");
        }
        if (args != null && args.boundingBox != null) {
            this.boundingBox = args.boundingBox;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[boundingBox] is unset!");
        }
        if (args != null && args.displayName != null) {
            this.displayName = args.displayName;
        }
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        if (args != null && args.faceId != null) {
            if (typeof args.faceId === "number") {
                this.faceId = new Int64(args.faceId);
            }
            else {
                this.faceId = args.faceId;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[faceId] is unset!");
        }
        if (args != null && args.localFaceId != null) {
            this.localFaceId = args.localFaceId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[localFaceId] is unset!");
        }
        if (args != null && args.notSure != null) {
            this.notSure = args.notSure;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[notSure] is unset!");
        }
        if (args != null && args.nameOnly != null) {
            this.nameOnly = args.nameOnly;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[nameOnly] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixAlbumFace");
        if (this.photoUrl != null) {
            output.writeFieldBegin("photoUrl", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.photoUrl);
            output.writeFieldEnd();
        }
        if (this.boundingBox != null) {
            output.writeFieldBegin("boundingBox", thrift.Thrift.Type.STRUCT, 2);
            this.boundingBox.write(output);
            output.writeFieldEnd();
        }
        if (this.displayName != null) {
            output.writeFieldBegin("displayName", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.displayName);
            output.writeFieldEnd();
        }
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.faceId != null) {
            output.writeFieldBegin("faceId", thrift.Thrift.Type.I64, 6);
            output.writeI64(this.faceId);
            output.writeFieldEnd();
        }
        if (this.localFaceId != null) {
            output.writeFieldBegin("localFaceId", thrift.Thrift.Type.STRING, 7);
            output.writeString(this.localFaceId);
            output.writeFieldEnd();
        }
        if (this.notSure != null) {
            output.writeFieldBegin("notSure", thrift.Thrift.Type.BOOL, 8);
            output.writeBool(this.notSure);
            output.writeFieldEnd();
        }
        if (this.nameOnly != null) {
            output.writeFieldBegin("nameOnly", thrift.Thrift.Type.BOOL, 9);
            output.writeBool(this.nameOnly);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixAlbumFace {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_40: string = input.readString();
                        _args.photoUrl = value_40;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_41: TAppPhoenixFaceBoundingBox = TAppPhoenixFaceBoundingBox.read(input);
                        _args.boundingBox = value_41;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_42: string = input.readString();
                        _args.displayName = value_42;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_43: string = input.readString();
                        _args.contactId = value_43;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_44: string = input.readString();
                        _args.userId = value_44;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_45: Int64 = input.readI64();
                        _args.faceId = value_45;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_46: string = input.readString();
                        _args.localFaceId = value_46;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_47: boolean = input.readBool();
                        _args.notSure = value_47;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_48: boolean = input.readBool();
                        _args.nameOnly = value_48;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.photoUrl !== undefined && _args.boundingBox !== undefined && _args.faceId !== undefined && _args.localFaceId !== undefined && _args.notSure !== undefined && _args.nameOnly !== undefined) {
            return new TAppPhoenixAlbumFace(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixAlbumFace from input");
        }
    }
}
export interface ITAppPhoenixPhotoFaceArgs {
    localFaceId: string;
    canonicalFaceId: number | Int64;
    boundingBox: TAppPhoenixFaceBoundingBox;
}
export class TAppPhoenixPhotoFace {
    public localFaceId: string;
    public canonicalFaceId: Int64;
    public boundingBox: TAppPhoenixFaceBoundingBox;
    constructor(args: ITAppPhoenixPhotoFaceArgs) {
        if (args != null && args.localFaceId != null) {
            this.localFaceId = args.localFaceId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[localFaceId] is unset!");
        }
        if (args != null && args.canonicalFaceId != null) {
            if (typeof args.canonicalFaceId === "number") {
                this.canonicalFaceId = new Int64(args.canonicalFaceId);
            }
            else {
                this.canonicalFaceId = args.canonicalFaceId;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[canonicalFaceId] is unset!");
        }
        if (args != null && args.boundingBox != null) {
            this.boundingBox = args.boundingBox;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[boundingBox] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixPhotoFace");
        if (this.localFaceId != null) {
            output.writeFieldBegin("localFaceId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.localFaceId);
            output.writeFieldEnd();
        }
        if (this.canonicalFaceId != null) {
            output.writeFieldBegin("canonicalFaceId", thrift.Thrift.Type.I64, 2);
            output.writeI64(this.canonicalFaceId);
            output.writeFieldEnd();
        }
        if (this.boundingBox != null) {
            output.writeFieldBegin("boundingBox", thrift.Thrift.Type.STRUCT, 3);
            this.boundingBox.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixPhotoFace {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_49: string = input.readString();
                        _args.localFaceId = value_49;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_50: Int64 = input.readI64();
                        _args.canonicalFaceId = value_50;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_51: TAppPhoenixFaceBoundingBox = TAppPhoenixFaceBoundingBox.read(input);
                        _args.boundingBox = value_51;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.localFaceId !== undefined && _args.canonicalFaceId !== undefined && _args.boundingBox !== undefined) {
            return new TAppPhoenixPhotoFace(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixPhotoFace from input");
        }
    }
}
export interface ITAppPhoenixAlbumArgs {
    albumMeta?: TAppPhoenixAlbumMeta;
    albumUserMeta: TAppPhoenixAlbumUserMeta;
    colocatedUsers?: Array<TAppPhoenixUser>;
    photos?: Array<TAppPhoenixPhotoMeta>;
    skippedPhotos?: Array<TAppPhoenixPhotoMeta>;
    albumFaces?: Array<TAppPhoenixAlbumFace>;
    taggableFaces?: Array<TAppPhoenixAlbumFace>;
    title?: string;
    startTs?: number | Int64;
    endTs?: number | Int64;
    location?: TAppPhoenixCoordinateLocation;
    albumId?: string;
    addressInfo?: PContact.TAppAddress;
}
export class TAppPhoenixAlbum {
    public albumMeta?: TAppPhoenixAlbumMeta;
    public albumUserMeta: TAppPhoenixAlbumUserMeta;
    public colocatedUsers?: Array<TAppPhoenixUser>;
    public photos?: Array<TAppPhoenixPhotoMeta>;
    public skippedPhotos?: Array<TAppPhoenixPhotoMeta>;
    public albumFaces?: Array<TAppPhoenixAlbumFace>;
    public taggableFaces?: Array<TAppPhoenixAlbumFace>;
    public title?: string;
    public startTs?: Int64;
    public endTs?: Int64;
    public location?: TAppPhoenixCoordinateLocation;
    public albumId?: string;
    public addressInfo?: PContact.TAppAddress;
    constructor(args: ITAppPhoenixAlbumArgs) {
        if (args != null && args.albumMeta != null) {
            this.albumMeta = args.albumMeta;
        }
        if (args != null && args.albumUserMeta != null) {
            this.albumUserMeta = args.albumUserMeta;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumUserMeta] is unset!");
        }
        if (args != null && args.colocatedUsers != null) {
            this.colocatedUsers = args.colocatedUsers;
        }
        if (args != null && args.photos != null) {
            this.photos = args.photos;
        }
        if (args != null && args.skippedPhotos != null) {
            this.skippedPhotos = args.skippedPhotos;
        }
        if (args != null && args.albumFaces != null) {
            this.albumFaces = args.albumFaces;
        }
        if (args != null && args.taggableFaces != null) {
            this.taggableFaces = args.taggableFaces;
        }
        if (args != null && args.title != null) {
            this.title = args.title;
        }
        if (args != null && args.startTs != null) {
            if (typeof args.startTs === "number") {
                this.startTs = new Int64(args.startTs);
            }
            else {
                this.startTs = args.startTs;
            }
        }
        if (args != null && args.endTs != null) {
            if (typeof args.endTs === "number") {
                this.endTs = new Int64(args.endTs);
            }
            else {
                this.endTs = args.endTs;
            }
        }
        if (args != null && args.location != null) {
            this.location = args.location;
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        if (args != null && args.addressInfo != null) {
            this.addressInfo = args.addressInfo;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixAlbum");
        if (this.albumMeta != null) {
            output.writeFieldBegin("albumMeta", thrift.Thrift.Type.STRUCT, 9);
            this.albumMeta.write(output);
            output.writeFieldEnd();
        }
        if (this.albumUserMeta != null) {
            output.writeFieldBegin("albumUserMeta", thrift.Thrift.Type.STRUCT, 11);
            this.albumUserMeta.write(output);
            output.writeFieldEnd();
        }
        if (this.colocatedUsers != null) {
            output.writeFieldBegin("colocatedUsers", thrift.Thrift.Type.LIST, 5);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.colocatedUsers.length);
            this.colocatedUsers.forEach((value_52: TAppPhoenixUser): void => {
                value_52.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.photos != null) {
            output.writeFieldBegin("photos", thrift.Thrift.Type.LIST, 6);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.photos.length);
            this.photos.forEach((value_53: TAppPhoenixPhotoMeta): void => {
                value_53.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.skippedPhotos != null) {
            output.writeFieldBegin("skippedPhotos", thrift.Thrift.Type.LIST, 10);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.skippedPhotos.length);
            this.skippedPhotos.forEach((value_54: TAppPhoenixPhotoMeta): void => {
                value_54.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.albumFaces != null) {
            output.writeFieldBegin("albumFaces", thrift.Thrift.Type.LIST, 12);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.albumFaces.length);
            this.albumFaces.forEach((value_55: TAppPhoenixAlbumFace): void => {
                value_55.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.taggableFaces != null) {
            output.writeFieldBegin("taggableFaces", thrift.Thrift.Type.LIST, 13);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.taggableFaces.length);
            this.taggableFaces.forEach((value_56: TAppPhoenixAlbumFace): void => {
                value_56.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.title != null) {
            output.writeFieldBegin("title", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.title);
            output.writeFieldEnd();
        }
        if (this.startTs != null) {
            output.writeFieldBegin("startTs", thrift.Thrift.Type.I64, 2);
            output.writeI64(this.startTs);
            output.writeFieldEnd();
        }
        if (this.endTs != null) {
            output.writeFieldBegin("endTs", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.endTs);
            output.writeFieldEnd();
        }
        if (this.location != null) {
            output.writeFieldBegin("location", thrift.Thrift.Type.STRUCT, 4);
            this.location.write(output);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 7);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.addressInfo != null) {
            output.writeFieldBegin("addressInfo", thrift.Thrift.Type.STRUCT, 8);
            this.addressInfo.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixAlbum {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 9:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_57: TAppPhoenixAlbumMeta = TAppPhoenixAlbumMeta.read(input);
                        _args.albumMeta = value_57;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_58: TAppPhoenixAlbumUserMeta = TAppPhoenixAlbumUserMeta.read(input);
                        _args.albumUserMeta = value_58;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_59: Array<TAppPhoenixUser> = new Array<TAppPhoenixUser>();
                        const metadata_3: thrift.TList = input.readListBegin();
                        const size_3: number = metadata_3.size;
                        for (let i_3: number = 0; i_3 < size_3; i_3++) {
                            const value_60: TAppPhoenixUser = TAppPhoenixUser.read(input);
                            value_59.push(value_60);
                        }
                        input.readListEnd();
                        _args.colocatedUsers = value_59;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_61: Array<TAppPhoenixPhotoMeta> = new Array<TAppPhoenixPhotoMeta>();
                        const metadata_4: thrift.TList = input.readListBegin();
                        const size_4: number = metadata_4.size;
                        for (let i_4: number = 0; i_4 < size_4; i_4++) {
                            const value_62: TAppPhoenixPhotoMeta = TAppPhoenixPhotoMeta.read(input);
                            value_61.push(value_62);
                        }
                        input.readListEnd();
                        _args.photos = value_61;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_63: Array<TAppPhoenixPhotoMeta> = new Array<TAppPhoenixPhotoMeta>();
                        const metadata_5: thrift.TList = input.readListBegin();
                        const size_5: number = metadata_5.size;
                        for (let i_5: number = 0; i_5 < size_5; i_5++) {
                            const value_64: TAppPhoenixPhotoMeta = TAppPhoenixPhotoMeta.read(input);
                            value_63.push(value_64);
                        }
                        input.readListEnd();
                        _args.skippedPhotos = value_63;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_65: Array<TAppPhoenixAlbumFace> = new Array<TAppPhoenixAlbumFace>();
                        const metadata_6: thrift.TList = input.readListBegin();
                        const size_6: number = metadata_6.size;
                        for (let i_6: number = 0; i_6 < size_6; i_6++) {
                            const value_66: TAppPhoenixAlbumFace = TAppPhoenixAlbumFace.read(input);
                            value_65.push(value_66);
                        }
                        input.readListEnd();
                        _args.albumFaces = value_65;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 13:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_67: Array<TAppPhoenixAlbumFace> = new Array<TAppPhoenixAlbumFace>();
                        const metadata_7: thrift.TList = input.readListBegin();
                        const size_7: number = metadata_7.size;
                        for (let i_7: number = 0; i_7 < size_7; i_7++) {
                            const value_68: TAppPhoenixAlbumFace = TAppPhoenixAlbumFace.read(input);
                            value_67.push(value_68);
                        }
                        input.readListEnd();
                        _args.taggableFaces = value_67;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_69: string = input.readString();
                        _args.title = value_69;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_70: Int64 = input.readI64();
                        _args.startTs = value_70;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_71: Int64 = input.readI64();
                        _args.endTs = value_71;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_72: TAppPhoenixCoordinateLocation = TAppPhoenixCoordinateLocation.read(input);
                        _args.location = value_72;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_73: string = input.readString();
                        _args.albumId = value_73;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_74: PContact.TAppAddress = PContact.TAppAddress.read(input);
                        _args.addressInfo = value_74;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumUserMeta !== undefined) {
            return new TAppPhoenixAlbum(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixAlbum from input");
        }
    }
}
export interface ITAppPhoenixAlbumUserMetaArgs {
    joinTs: number | Int64;
    uploadMode: TAppPhoenixPhotoUploadMode;
    invitedUserIds: Array<string>;
    invitedContactIds: Array<string>;
    processingPhotoIds: Array<string>;
    archiveShareSuggestionBitmask: number | Int64;
    notificationEnabled: boolean;
}
export class TAppPhoenixAlbumUserMeta {
    public joinTs: Int64;
    public uploadMode: TAppPhoenixPhotoUploadMode;
    public invitedUserIds: Array<string>;
    public invitedContactIds: Array<string>;
    public processingPhotoIds: Array<string>;
    public archiveShareSuggestionBitmask: Int64;
    public notificationEnabled: boolean;
    constructor(args: ITAppPhoenixAlbumUserMetaArgs) {
        if (args != null && args.joinTs != null) {
            if (typeof args.joinTs === "number") {
                this.joinTs = new Int64(args.joinTs);
            }
            else {
                this.joinTs = args.joinTs;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[joinTs] is unset!");
        }
        if (args != null && args.uploadMode != null) {
            this.uploadMode = args.uploadMode;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[uploadMode] is unset!");
        }
        if (args != null && args.invitedUserIds != null) {
            this.invitedUserIds = args.invitedUserIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[invitedUserIds] is unset!");
        }
        if (args != null && args.invitedContactIds != null) {
            this.invitedContactIds = args.invitedContactIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[invitedContactIds] is unset!");
        }
        if (args != null && args.processingPhotoIds != null) {
            this.processingPhotoIds = args.processingPhotoIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[processingPhotoIds] is unset!");
        }
        if (args != null && args.archiveShareSuggestionBitmask != null) {
            if (typeof args.archiveShareSuggestionBitmask === "number") {
                this.archiveShareSuggestionBitmask = new Int64(args.archiveShareSuggestionBitmask);
            }
            else {
                this.archiveShareSuggestionBitmask = args.archiveShareSuggestionBitmask;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[archiveShareSuggestionBitmask] is unset!");
        }
        if (args != null && args.notificationEnabled != null) {
            this.notificationEnabled = args.notificationEnabled;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[notificationEnabled] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixAlbumUserMeta");
        if (this.joinTs != null) {
            output.writeFieldBegin("joinTs", thrift.Thrift.Type.I64, 1);
            output.writeI64(this.joinTs);
            output.writeFieldEnd();
        }
        if (this.uploadMode != null) {
            output.writeFieldBegin("uploadMode", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.uploadMode);
            output.writeFieldEnd();
        }
        if (this.invitedUserIds != null) {
            output.writeFieldBegin("invitedUserIds", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.invitedUserIds.length);
            this.invitedUserIds.forEach((value_75: string): void => {
                output.writeString(value_75);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.invitedContactIds != null) {
            output.writeFieldBegin("invitedContactIds", thrift.Thrift.Type.LIST, 4);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.invitedContactIds.length);
            this.invitedContactIds.forEach((value_76: string): void => {
                output.writeString(value_76);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.processingPhotoIds != null) {
            output.writeFieldBegin("processingPhotoIds", thrift.Thrift.Type.LIST, 5);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.processingPhotoIds.length);
            this.processingPhotoIds.forEach((value_77: string): void => {
                output.writeString(value_77);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.archiveShareSuggestionBitmask != null) {
            output.writeFieldBegin("archiveShareSuggestionBitmask", thrift.Thrift.Type.I64, 6);
            output.writeI64(this.archiveShareSuggestionBitmask);
            output.writeFieldEnd();
        }
        if (this.notificationEnabled != null) {
            output.writeFieldBegin("notificationEnabled", thrift.Thrift.Type.BOOL, 7);
            output.writeBool(this.notificationEnabled);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixAlbumUserMeta {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_78: Int64 = input.readI64();
                        _args.joinTs = value_78;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_79: TAppPhoenixPhotoUploadMode = input.readI32();
                        _args.uploadMode = value_79;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_80: Array<string> = new Array<string>();
                        const metadata_8: thrift.TList = input.readListBegin();
                        const size_8: number = metadata_8.size;
                        for (let i_8: number = 0; i_8 < size_8; i_8++) {
                            const value_81: string = input.readString();
                            value_80.push(value_81);
                        }
                        input.readListEnd();
                        _args.invitedUserIds = value_80;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_82: Array<string> = new Array<string>();
                        const metadata_9: thrift.TList = input.readListBegin();
                        const size_9: number = metadata_9.size;
                        for (let i_9: number = 0; i_9 < size_9; i_9++) {
                            const value_83: string = input.readString();
                            value_82.push(value_83);
                        }
                        input.readListEnd();
                        _args.invitedContactIds = value_82;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_84: Array<string> = new Array<string>();
                        const metadata_10: thrift.TList = input.readListBegin();
                        const size_10: number = metadata_10.size;
                        for (let i_10: number = 0; i_10 < size_10; i_10++) {
                            const value_85: string = input.readString();
                            value_84.push(value_85);
                        }
                        input.readListEnd();
                        _args.processingPhotoIds = value_84;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_86: Int64 = input.readI64();
                        _args.archiveShareSuggestionBitmask = value_86;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_87: boolean = input.readBool();
                        _args.notificationEnabled = value_87;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.joinTs !== undefined && _args.uploadMode !== undefined && _args.invitedUserIds !== undefined && _args.invitedContactIds !== undefined && _args.processingPhotoIds !== undefined && _args.archiveShareSuggestionBitmask !== undefined && _args.notificationEnabled !== undefined) {
            return new TAppPhoenixAlbumUserMeta(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixAlbumUserMeta from input");
        }
    }
}
export interface ITAppPhoenixAlbumSuggestionArgs {
    albumSuggestionUuid: string;
    title?: string;
    startTs?: number | Int64;
    endTs?: number | Int64;
    location?: TAppPhoenixCoordinateLocation;
    colocatedUsers?: Array<TAppPhoenixUser>;
    photos?: Array<TAppPhoenixPhotoMeta>;
    addressInfo?: PContact.TAppAddress;
}
export class TAppPhoenixAlbumSuggestion {
    public albumSuggestionUuid: string;
    public title?: string;
    public startTs?: Int64;
    public endTs?: Int64;
    public location?: TAppPhoenixCoordinateLocation;
    public colocatedUsers?: Array<TAppPhoenixUser>;
    public photos?: Array<TAppPhoenixPhotoMeta>;
    public addressInfo?: PContact.TAppAddress;
    constructor(args: ITAppPhoenixAlbumSuggestionArgs) {
        if (args != null && args.albumSuggestionUuid != null) {
            this.albumSuggestionUuid = args.albumSuggestionUuid;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumSuggestionUuid] is unset!");
        }
        if (args != null && args.title != null) {
            this.title = args.title;
        }
        if (args != null && args.startTs != null) {
            if (typeof args.startTs === "number") {
                this.startTs = new Int64(args.startTs);
            }
            else {
                this.startTs = args.startTs;
            }
        }
        if (args != null && args.endTs != null) {
            if (typeof args.endTs === "number") {
                this.endTs = new Int64(args.endTs);
            }
            else {
                this.endTs = args.endTs;
            }
        }
        if (args != null && args.location != null) {
            this.location = args.location;
        }
        if (args != null && args.colocatedUsers != null) {
            this.colocatedUsers = args.colocatedUsers;
        }
        if (args != null && args.photos != null) {
            this.photos = args.photos;
        }
        if (args != null && args.addressInfo != null) {
            this.addressInfo = args.addressInfo;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixAlbumSuggestion");
        if (this.albumSuggestionUuid != null) {
            output.writeFieldBegin("albumSuggestionUuid", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumSuggestionUuid);
            output.writeFieldEnd();
        }
        if (this.title != null) {
            output.writeFieldBegin("title", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.title);
            output.writeFieldEnd();
        }
        if (this.startTs != null) {
            output.writeFieldBegin("startTs", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.startTs);
            output.writeFieldEnd();
        }
        if (this.endTs != null) {
            output.writeFieldBegin("endTs", thrift.Thrift.Type.I64, 4);
            output.writeI64(this.endTs);
            output.writeFieldEnd();
        }
        if (this.location != null) {
            output.writeFieldBegin("location", thrift.Thrift.Type.STRUCT, 5);
            this.location.write(output);
            output.writeFieldEnd();
        }
        if (this.colocatedUsers != null) {
            output.writeFieldBegin("colocatedUsers", thrift.Thrift.Type.LIST, 6);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.colocatedUsers.length);
            this.colocatedUsers.forEach((value_88: TAppPhoenixUser): void => {
                value_88.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.photos != null) {
            output.writeFieldBegin("photos", thrift.Thrift.Type.LIST, 7);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.photos.length);
            this.photos.forEach((value_89: TAppPhoenixPhotoMeta): void => {
                value_89.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.addressInfo != null) {
            output.writeFieldBegin("addressInfo", thrift.Thrift.Type.STRUCT, 8);
            this.addressInfo.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixAlbumSuggestion {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_90: string = input.readString();
                        _args.albumSuggestionUuid = value_90;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_91: string = input.readString();
                        _args.title = value_91;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_92: Int64 = input.readI64();
                        _args.startTs = value_92;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_93: Int64 = input.readI64();
                        _args.endTs = value_93;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_94: TAppPhoenixCoordinateLocation = TAppPhoenixCoordinateLocation.read(input);
                        _args.location = value_94;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_95: Array<TAppPhoenixUser> = new Array<TAppPhoenixUser>();
                        const metadata_11: thrift.TList = input.readListBegin();
                        const size_11: number = metadata_11.size;
                        for (let i_11: number = 0; i_11 < size_11; i_11++) {
                            const value_96: TAppPhoenixUser = TAppPhoenixUser.read(input);
                            value_95.push(value_96);
                        }
                        input.readListEnd();
                        _args.colocatedUsers = value_95;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_97: Array<TAppPhoenixPhotoMeta> = new Array<TAppPhoenixPhotoMeta>();
                        const metadata_12: thrift.TList = input.readListBegin();
                        const size_12: number = metadata_12.size;
                        for (let i_12: number = 0; i_12 < size_12; i_12++) {
                            const value_98: TAppPhoenixPhotoMeta = TAppPhoenixPhotoMeta.read(input);
                            value_97.push(value_98);
                        }
                        input.readListEnd();
                        _args.photos = value_97;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_99: PContact.TAppAddress = PContact.TAppAddress.read(input);
                        _args.addressInfo = value_99;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumSuggestionUuid !== undefined) {
            return new TAppPhoenixAlbumSuggestion(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixAlbumSuggestion from input");
        }
    }
}
export interface ITAppPhoenixPhotoMetaArgs {
    userId: string;
    photoId: string;
    filename: string;
    photoTs?: number | Int64;
    numFaces?: number;
    fullsizeUrl?: string;
    thumbnailUrl?: string;
    exif?: string;
    exifAux?: string;
    photoLocation?: TAppPhoenixPhotoLocation;
    isPublic?: boolean;
    clusterId?: number | Int64;
    reactions?: Array<TAppPhoenixReaction>;
    comments?: Array<TAppPhoenixComment>;
    isKeyPhoto?: boolean;
    skippedReasons?: Array<TAppPhoenixPhotoExclusionReason>;
    isInvitation?: boolean;
    offsetInSeconds?: number;
    faceIds?: Array<Int64>;
    faces?: Array<TAppPhoenixPhotoFace>;
}
export class TAppPhoenixPhotoMeta {
    public userId: string;
    public photoId: string;
    public filename: string;
    public photoTs?: Int64;
    public numFaces?: number;
    public fullsizeUrl?: string;
    public thumbnailUrl?: string;
    public exif?: string;
    public exifAux?: string;
    public photoLocation?: TAppPhoenixPhotoLocation;
    public isPublic?: boolean;
    public clusterId?: Int64;
    public reactions?: Array<TAppPhoenixReaction>;
    public comments?: Array<TAppPhoenixComment>;
    public isKeyPhoto?: boolean;
    public skippedReasons?: Array<TAppPhoenixPhotoExclusionReason>;
    public isInvitation?: boolean;
    public offsetInSeconds?: number;
    public faceIds?: Array<Int64>;
    public faces?: Array<TAppPhoenixPhotoFace>;
    constructor(args: ITAppPhoenixPhotoMetaArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.photoId != null) {
            this.photoId = args.photoId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoId] is unset!");
        }
        if (args != null && args.filename != null) {
            this.filename = args.filename;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[filename] is unset!");
        }
        if (args != null && args.photoTs != null) {
            if (typeof args.photoTs === "number") {
                this.photoTs = new Int64(args.photoTs);
            }
            else {
                this.photoTs = args.photoTs;
            }
        }
        if (args != null && args.numFaces != null) {
            this.numFaces = args.numFaces;
        }
        if (args != null && args.fullsizeUrl != null) {
            this.fullsizeUrl = args.fullsizeUrl;
        }
        if (args != null && args.thumbnailUrl != null) {
            this.thumbnailUrl = args.thumbnailUrl;
        }
        if (args != null && args.exif != null) {
            this.exif = args.exif;
        }
        if (args != null && args.exifAux != null) {
            this.exifAux = args.exifAux;
        }
        if (args != null && args.photoLocation != null) {
            this.photoLocation = args.photoLocation;
        }
        if (args != null && args.isPublic != null) {
            this.isPublic = args.isPublic;
        }
        if (args != null && args.clusterId != null) {
            if (typeof args.clusterId === "number") {
                this.clusterId = new Int64(args.clusterId);
            }
            else {
                this.clusterId = args.clusterId;
            }
        }
        if (args != null && args.reactions != null) {
            this.reactions = args.reactions;
        }
        if (args != null && args.comments != null) {
            this.comments = args.comments;
        }
        if (args != null && args.isKeyPhoto != null) {
            this.isKeyPhoto = args.isKeyPhoto;
        }
        if (args != null && args.skippedReasons != null) {
            this.skippedReasons = args.skippedReasons;
        }
        if (args != null && args.isInvitation != null) {
            this.isInvitation = args.isInvitation;
        }
        if (args != null && args.offsetInSeconds != null) {
            this.offsetInSeconds = args.offsetInSeconds;
        }
        if (args != null && args.faceIds != null) {
            this.faceIds = args.faceIds;
        }
        if (args != null && args.faces != null) {
            this.faces = args.faces;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixPhotoMeta");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.photoId != null) {
            output.writeFieldBegin("photoId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.photoId);
            output.writeFieldEnd();
        }
        if (this.filename != null) {
            output.writeFieldBegin("filename", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.filename);
            output.writeFieldEnd();
        }
        if (this.photoTs != null) {
            output.writeFieldBegin("photoTs", thrift.Thrift.Type.I64, 4);
            output.writeI64(this.photoTs);
            output.writeFieldEnd();
        }
        if (this.numFaces != null) {
            output.writeFieldBegin("numFaces", thrift.Thrift.Type.I32, 5);
            output.writeI32(this.numFaces);
            output.writeFieldEnd();
        }
        if (this.fullsizeUrl != null) {
            output.writeFieldBegin("fullsizeUrl", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.fullsizeUrl);
            output.writeFieldEnd();
        }
        if (this.thumbnailUrl != null) {
            output.writeFieldBegin("thumbnailUrl", thrift.Thrift.Type.STRING, 7);
            output.writeString(this.thumbnailUrl);
            output.writeFieldEnd();
        }
        if (this.exif != null) {
            output.writeFieldBegin("exif", thrift.Thrift.Type.STRING, 8);
            output.writeString(this.exif);
            output.writeFieldEnd();
        }
        if (this.exifAux != null) {
            output.writeFieldBegin("exifAux", thrift.Thrift.Type.STRING, 9);
            output.writeString(this.exifAux);
            output.writeFieldEnd();
        }
        if (this.photoLocation != null) {
            output.writeFieldBegin("photoLocation", thrift.Thrift.Type.STRUCT, 10);
            this.photoLocation.write(output);
            output.writeFieldEnd();
        }
        if (this.isPublic != null) {
            output.writeFieldBegin("isPublic", thrift.Thrift.Type.BOOL, 11);
            output.writeBool(this.isPublic);
            output.writeFieldEnd();
        }
        if (this.clusterId != null) {
            output.writeFieldBegin("clusterId", thrift.Thrift.Type.I64, 12);
            output.writeI64(this.clusterId);
            output.writeFieldEnd();
        }
        if (this.reactions != null) {
            output.writeFieldBegin("reactions", thrift.Thrift.Type.LIST, 13);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.reactions.length);
            this.reactions.forEach((value_100: TAppPhoenixReaction): void => {
                value_100.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.comments != null) {
            output.writeFieldBegin("comments", thrift.Thrift.Type.LIST, 14);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.comments.length);
            this.comments.forEach((value_101: TAppPhoenixComment): void => {
                value_101.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.isKeyPhoto != null) {
            output.writeFieldBegin("isKeyPhoto", thrift.Thrift.Type.BOOL, 15);
            output.writeBool(this.isKeyPhoto);
            output.writeFieldEnd();
        }
        if (this.skippedReasons != null) {
            output.writeFieldBegin("skippedReasons", thrift.Thrift.Type.LIST, 17);
            output.writeListBegin(thrift.Thrift.Type.I32, this.skippedReasons.length);
            this.skippedReasons.forEach((value_102: TAppPhoenixPhotoExclusionReason): void => {
                output.writeI32(value_102);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.isInvitation != null) {
            output.writeFieldBegin("isInvitation", thrift.Thrift.Type.BOOL, 18);
            output.writeBool(this.isInvitation);
            output.writeFieldEnd();
        }
        if (this.offsetInSeconds != null) {
            output.writeFieldBegin("offsetInSeconds", thrift.Thrift.Type.I32, 19);
            output.writeI32(this.offsetInSeconds);
            output.writeFieldEnd();
        }
        if (this.faceIds != null) {
            output.writeFieldBegin("faceIds", thrift.Thrift.Type.LIST, 20);
            output.writeListBegin(thrift.Thrift.Type.I64, this.faceIds.length);
            this.faceIds.forEach((value_103: Int64): void => {
                output.writeI64(value_103);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.faces != null) {
            output.writeFieldBegin("faces", thrift.Thrift.Type.LIST, 21);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.faces.length);
            this.faces.forEach((value_104: TAppPhoenixPhotoFace): void => {
                value_104.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixPhotoMeta {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_105: string = input.readString();
                        _args.userId = value_105;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_106: string = input.readString();
                        _args.photoId = value_106;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_107: string = input.readString();
                        _args.filename = value_107;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_108: Int64 = input.readI64();
                        _args.photoTs = value_108;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_109: number = input.readI32();
                        _args.numFaces = value_109;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_110: string = input.readString();
                        _args.fullsizeUrl = value_110;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_111: string = input.readString();
                        _args.thumbnailUrl = value_111;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_112: string = input.readString();
                        _args.exif = value_112;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_113: string = input.readString();
                        _args.exifAux = value_113;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 10:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_114: TAppPhoenixPhotoLocation = TAppPhoenixPhotoLocation.read(input);
                        _args.photoLocation = value_114;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 11:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_115: boolean = input.readBool();
                        _args.isPublic = value_115;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 12:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_116: Int64 = input.readI64();
                        _args.clusterId = value_116;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 13:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_117: Array<TAppPhoenixReaction> = new Array<TAppPhoenixReaction>();
                        const metadata_13: thrift.TList = input.readListBegin();
                        const size_13: number = metadata_13.size;
                        for (let i_13: number = 0; i_13 < size_13; i_13++) {
                            const value_118: TAppPhoenixReaction = TAppPhoenixReaction.read(input);
                            value_117.push(value_118);
                        }
                        input.readListEnd();
                        _args.reactions = value_117;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 14:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_119: Array<TAppPhoenixComment> = new Array<TAppPhoenixComment>();
                        const metadata_14: thrift.TList = input.readListBegin();
                        const size_14: number = metadata_14.size;
                        for (let i_14: number = 0; i_14 < size_14; i_14++) {
                            const value_120: TAppPhoenixComment = TAppPhoenixComment.read(input);
                            value_119.push(value_120);
                        }
                        input.readListEnd();
                        _args.comments = value_119;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 15:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_121: boolean = input.readBool();
                        _args.isKeyPhoto = value_121;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 17:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_122: Array<TAppPhoenixPhotoExclusionReason> = new Array<TAppPhoenixPhotoExclusionReason>();
                        const metadata_15: thrift.TList = input.readListBegin();
                        const size_15: number = metadata_15.size;
                        for (let i_15: number = 0; i_15 < size_15; i_15++) {
                            const value_123: TAppPhoenixPhotoExclusionReason = input.readI32();
                            value_122.push(value_123);
                        }
                        input.readListEnd();
                        _args.skippedReasons = value_122;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 18:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_124: boolean = input.readBool();
                        _args.isInvitation = value_124;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 19:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_125: number = input.readI32();
                        _args.offsetInSeconds = value_125;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 20:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_126: Array<Int64> = new Array<Int64>();
                        const metadata_16: thrift.TList = input.readListBegin();
                        const size_16: number = metadata_16.size;
                        for (let i_16: number = 0; i_16 < size_16; i_16++) {
                            const value_127: Int64 = input.readI64();
                            value_126.push(value_127);
                        }
                        input.readListEnd();
                        _args.faceIds = value_126;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 21:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_128: Array<TAppPhoenixPhotoFace> = new Array<TAppPhoenixPhotoFace>();
                        const metadata_17: thrift.TList = input.readListBegin();
                        const size_17: number = metadata_17.size;
                        for (let i_17: number = 0; i_17 < size_17; i_17++) {
                            const value_129: TAppPhoenixPhotoFace = TAppPhoenixPhotoFace.read(input);
                            value_128.push(value_129);
                        }
                        input.readListEnd();
                        _args.faces = value_128;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.photoId !== undefined && _args.filename !== undefined) {
            return new TAppPhoenixPhotoMeta(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixPhotoMeta from input");
        }
    }
}
export interface ITAppPhoenixReactionArgs {
    userId: string;
    reaction: string;
    createTs: number | Int64;
}
export class TAppPhoenixReaction {
    public userId: string;
    public reaction: string;
    public createTs: Int64;
    constructor(args: ITAppPhoenixReactionArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.reaction != null) {
            this.reaction = args.reaction;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[reaction] is unset!");
        }
        if (args != null && args.createTs != null) {
            if (typeof args.createTs === "number") {
                this.createTs = new Int64(args.createTs);
            }
            else {
                this.createTs = args.createTs;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[createTs] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixReaction");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.reaction != null) {
            output.writeFieldBegin("reaction", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.reaction);
            output.writeFieldEnd();
        }
        if (this.createTs != null) {
            output.writeFieldBegin("createTs", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.createTs);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixReaction {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_130: string = input.readString();
                        _args.userId = value_130;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_131: string = input.readString();
                        _args.reaction = value_131;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_132: Int64 = input.readI64();
                        _args.createTs = value_132;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.reaction !== undefined && _args.createTs !== undefined) {
            return new TAppPhoenixReaction(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixReaction from input");
        }
    }
}
export interface ITAppPhoenixCommentArgs {
    commentId: string;
    userId: string;
    comment: string;
    lastEditTs: number | Int64;
    isEdited?: boolean;
    parentCommentId?: string;
    createTs?: number | Int64;
}
export class TAppPhoenixComment {
    public commentId: string;
    public userId: string;
    public comment: string;
    public lastEditTs: Int64;
    public isEdited?: boolean;
    public parentCommentId?: string;
    public createTs?: Int64;
    constructor(args: ITAppPhoenixCommentArgs) {
        if (args != null && args.commentId != null) {
            this.commentId = args.commentId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[commentId] is unset!");
        }
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.comment != null) {
            this.comment = args.comment;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[comment] is unset!");
        }
        if (args != null && args.lastEditTs != null) {
            if (typeof args.lastEditTs === "number") {
                this.lastEditTs = new Int64(args.lastEditTs);
            }
            else {
                this.lastEditTs = args.lastEditTs;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[lastEditTs] is unset!");
        }
        if (args != null && args.isEdited != null) {
            this.isEdited = args.isEdited;
        }
        if (args != null && args.parentCommentId != null) {
            this.parentCommentId = args.parentCommentId;
        }
        if (args != null && args.createTs != null) {
            if (typeof args.createTs === "number") {
                this.createTs = new Int64(args.createTs);
            }
            else {
                this.createTs = args.createTs;
            }
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixComment");
        if (this.commentId != null) {
            output.writeFieldBegin("commentId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.commentId);
            output.writeFieldEnd();
        }
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.comment != null) {
            output.writeFieldBegin("comment", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.comment);
            output.writeFieldEnd();
        }
        if (this.lastEditTs != null) {
            output.writeFieldBegin("lastEditTs", thrift.Thrift.Type.I64, 4);
            output.writeI64(this.lastEditTs);
            output.writeFieldEnd();
        }
        if (this.isEdited != null) {
            output.writeFieldBegin("isEdited", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.isEdited);
            output.writeFieldEnd();
        }
        if (this.parentCommentId != null) {
            output.writeFieldBegin("parentCommentId", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.parentCommentId);
            output.writeFieldEnd();
        }
        if (this.createTs != null) {
            output.writeFieldBegin("createTs", thrift.Thrift.Type.I64, 7);
            output.writeI64(this.createTs);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixComment {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_133: string = input.readString();
                        _args.commentId = value_133;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_134: string = input.readString();
                        _args.userId = value_134;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_135: string = input.readString();
                        _args.comment = value_135;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_136: Int64 = input.readI64();
                        _args.lastEditTs = value_136;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_137: boolean = input.readBool();
                        _args.isEdited = value_137;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_138: string = input.readString();
                        _args.parentCommentId = value_138;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_139: Int64 = input.readI64();
                        _args.createTs = value_139;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.commentId !== undefined && _args.userId !== undefined && _args.comment !== undefined && _args.lastEditTs !== undefined) {
            return new TAppPhoenixComment(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixComment from input");
        }
    }
}
export interface ITAppPhoenixPhotoLocationArgs {
    timestamp?: number;
    location?: TAppPhoenixCoordinateLocation;
}
export class TAppPhoenixPhotoLocation {
    public timestamp?: number;
    public location?: TAppPhoenixCoordinateLocation;
    constructor(args?: ITAppPhoenixPhotoLocationArgs) {
        if (args != null && args.timestamp != null) {
            this.timestamp = args.timestamp;
        }
        if (args != null && args.location != null) {
            this.location = args.location;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixPhotoLocation");
        if (this.timestamp != null) {
            output.writeFieldBegin("timestamp", thrift.Thrift.Type.DOUBLE, 1);
            output.writeDouble(this.timestamp);
            output.writeFieldEnd();
        }
        if (this.location != null) {
            output.writeFieldBegin("location", thrift.Thrift.Type.STRUCT, 2);
            this.location.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixPhotoLocation {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_140: number = input.readDouble();
                        _args.timestamp = value_140;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_141: TAppPhoenixCoordinateLocation = TAppPhoenixCoordinateLocation.read(input);
                        _args.location = value_141;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppPhoenixPhotoLocation(_args);
    }
}
export interface ITAppPhoenixFaceArgs {
    ownerUserId: string;
    photoUrl: string;
    name?: string;
    isSignificant?: boolean;
}
export class TAppPhoenixFace {
    public ownerUserId: string;
    public photoUrl: string;
    public name?: string;
    public isSignificant?: boolean;
    constructor(args: ITAppPhoenixFaceArgs) {
        if (args != null && args.ownerUserId != null) {
            this.ownerUserId = args.ownerUserId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[ownerUserId] is unset!");
        }
        if (args != null && args.photoUrl != null) {
            this.photoUrl = args.photoUrl;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoUrl] is unset!");
        }
        if (args != null && args.name != null) {
            this.name = args.name;
        }
        if (args != null && args.isSignificant != null) {
            this.isSignificant = args.isSignificant;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixFace");
        if (this.ownerUserId != null) {
            output.writeFieldBegin("ownerUserId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.ownerUserId);
            output.writeFieldEnd();
        }
        if (this.photoUrl != null) {
            output.writeFieldBegin("photoUrl", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.photoUrl);
            output.writeFieldEnd();
        }
        if (this.name != null) {
            output.writeFieldBegin("name", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.name);
            output.writeFieldEnd();
        }
        if (this.isSignificant != null) {
            output.writeFieldBegin("isSignificant", thrift.Thrift.Type.BOOL, 4);
            output.writeBool(this.isSignificant);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixFace {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_142: string = input.readString();
                        _args.ownerUserId = value_142;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_143: string = input.readString();
                        _args.photoUrl = value_143;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_144: string = input.readString();
                        _args.name = value_144;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_145: boolean = input.readBool();
                        _args.isSignificant = value_145;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.ownerUserId !== undefined && _args.photoUrl !== undefined) {
            return new TAppPhoenixFace(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixFace from input");
        }
    }
}
export interface ITGetPhoenixUserRequestArgs {
    userId: string;
}
export class TGetPhoenixUserRequest {
    public userId: string;
    constructor(args: ITGetPhoenixUserRequestArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetPhoenixUserRequest");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetPhoenixUserRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_146: string = input.readString();
                        _args.userId = value_146;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined) {
            return new TGetPhoenixUserRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TGetPhoenixUserRequest from input");
        }
    }
}
export interface ITGetPhoenixUserResponseArgs {
    user?: TAppPhoenixUser;
}
export class TGetPhoenixUserResponse {
    public user?: TAppPhoenixUser;
    constructor(args?: ITGetPhoenixUserResponseArgs) {
        if (args != null && args.user != null) {
            this.user = args.user;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TGetPhoenixUserResponse");
        if (this.user != null) {
            output.writeFieldBegin("user", thrift.Thrift.Type.STRUCT, 1);
            this.user.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TGetPhoenixUserResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_147: TAppPhoenixUser = TAppPhoenixUser.read(input);
                        _args.user = value_147;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TGetPhoenixUserResponse(_args);
    }
}
export interface ITUpdatePhoenixUserRequestArgs {
    user: TAppPhoenixUser;
}
export class TUpdatePhoenixUserRequest {
    public user: TAppPhoenixUser;
    constructor(args: ITUpdatePhoenixUserRequestArgs) {
        if (args != null && args.user != null) {
            this.user = args.user;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[user] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdatePhoenixUserRequest");
        if (this.user != null) {
            output.writeFieldBegin("user", thrift.Thrift.Type.STRUCT, 1);
            this.user.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdatePhoenixUserRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_148: TAppPhoenixUser = TAppPhoenixUser.read(input);
                        _args.user = value_148;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.user !== undefined) {
            return new TUpdatePhoenixUserRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdatePhoenixUserRequest from input");
        }
    }
}
export interface ITUpdatePhoenixUserResponseArgs {
}
export class TUpdatePhoenixUserResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdatePhoenixUserResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdatePhoenixUserResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUpdatePhoenixUserResponse();
    }
}
export interface ITFetchAlbumRequestArgs {
    albumId: string;
}
export class TFetchAlbumRequest {
    public albumId: string;
    constructor(args: ITFetchAlbumRequestArgs) {
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchAlbumRequest");
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchAlbumRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_149: string = input.readString();
                        _args.albumId = value_149;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined) {
            return new TFetchAlbumRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchAlbumRequest from input");
        }
    }
}
export interface ITFetchAlbumResponseArgs {
    album?: TAppPhoenixAlbum;
    skippedPhotoIds?: Array<string>;
}
export class TFetchAlbumResponse {
    public album?: TAppPhoenixAlbum;
    public skippedPhotoIds?: Array<string>;
    constructor(args?: ITFetchAlbumResponseArgs) {
        if (args != null && args.album != null) {
            this.album = args.album;
        }
        if (args != null && args.skippedPhotoIds != null) {
            this.skippedPhotoIds = args.skippedPhotoIds;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchAlbumResponse");
        if (this.album != null) {
            output.writeFieldBegin("album", thrift.Thrift.Type.STRUCT, 1);
            this.album.write(output);
            output.writeFieldEnd();
        }
        if (this.skippedPhotoIds != null) {
            output.writeFieldBegin("skippedPhotoIds", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.skippedPhotoIds.length);
            this.skippedPhotoIds.forEach((value_150: string): void => {
                output.writeString(value_150);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchAlbumResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_151: TAppPhoenixAlbum = TAppPhoenixAlbum.read(input);
                        _args.album = value_151;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_152: Array<string> = new Array<string>();
                        const metadata_18: thrift.TList = input.readListBegin();
                        const size_18: number = metadata_18.size;
                        for (let i_18: number = 0; i_18 < size_18; i_18++) {
                            const value_153: string = input.readString();
                            value_152.push(value_153);
                        }
                        input.readListEnd();
                        _args.skippedPhotoIds = value_152;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchAlbumResponse(_args);
    }
}
export interface ITFetchAlbumsRequestArgs {
    userId: string;
    startIndex?: number;
    numRows?: number;
}
export class TFetchAlbumsRequest {
    public userId: string;
    public startIndex?: number;
    public numRows?: number;
    constructor(args: ITFetchAlbumsRequestArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.startIndex != null) {
            this.startIndex = args.startIndex;
        }
        if (args != null && args.numRows != null) {
            this.numRows = args.numRows;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchAlbumsRequest");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.startIndex != null) {
            output.writeFieldBegin("startIndex", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.startIndex);
            output.writeFieldEnd();
        }
        if (this.numRows != null) {
            output.writeFieldBegin("numRows", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.numRows);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchAlbumsRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_154: string = input.readString();
                        _args.userId = value_154;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_155: number = input.readI32();
                        _args.startIndex = value_155;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_156: number = input.readI32();
                        _args.numRows = value_156;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined) {
            return new TFetchAlbumsRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchAlbumsRequest from input");
        }
    }
}
export interface ITFetchAlbumsResponseArgs {
    totalCount: number;
    albums: Array<TAppPhoenixAlbum>;
    skippedPhotoIdsMap?: Map<string, Array<string>>;
}
export class TFetchAlbumsResponse {
    public totalCount: number;
    public albums: Array<TAppPhoenixAlbum>;
    public skippedPhotoIdsMap?: Map<string, Array<string>>;
    constructor(args: ITFetchAlbumsResponseArgs) {
        if (args != null && args.totalCount != null) {
            this.totalCount = args.totalCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[totalCount] is unset!");
        }
        if (args != null && args.albums != null) {
            this.albums = args.albums;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albums] is unset!");
        }
        if (args != null && args.skippedPhotoIdsMap != null) {
            this.skippedPhotoIdsMap = args.skippedPhotoIdsMap;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchAlbumsResponse");
        if (this.totalCount != null) {
            output.writeFieldBegin("totalCount", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.totalCount);
            output.writeFieldEnd();
        }
        if (this.albums != null) {
            output.writeFieldBegin("albums", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.albums.length);
            this.albums.forEach((value_157: TAppPhoenixAlbum): void => {
                value_157.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.skippedPhotoIdsMap != null) {
            output.writeFieldBegin("skippedPhotoIdsMap", thrift.Thrift.Type.MAP, 3);
            output.writeMapBegin(thrift.Thrift.Type.STRING, thrift.Thrift.Type.LIST, this.skippedPhotoIdsMap.size);
            this.skippedPhotoIdsMap.forEach((value_158: Array<string>, key_1: string): void => {
                output.writeString(key_1);
                output.writeListBegin(thrift.Thrift.Type.STRING, value_158.length);
                value_158.forEach((value_159: string): void => {
                    output.writeString(value_159);
                });
                output.writeListEnd();
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchAlbumsResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_160: number = input.readI32();
                        _args.totalCount = value_160;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_161: Array<TAppPhoenixAlbum> = new Array<TAppPhoenixAlbum>();
                        const metadata_19: thrift.TList = input.readListBegin();
                        const size_19: number = metadata_19.size;
                        for (let i_19: number = 0; i_19 < size_19; i_19++) {
                            const value_162: TAppPhoenixAlbum = TAppPhoenixAlbum.read(input);
                            value_161.push(value_162);
                        }
                        input.readListEnd();
                        _args.albums = value_161;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_163: Map<string, Array<string>> = new Map<string, Array<string>>();
                        const metadata_20: thrift.TMap = input.readMapBegin();
                        const size_20: number = metadata_20.size;
                        for (let i_20: number = 0; i_20 < size_20; i_20++) {
                            const key_2: string = input.readString();
                            const value_164: Array<string> = new Array<string>();
                            const metadata_21: thrift.TList = input.readListBegin();
                            const size_21: number = metadata_21.size;
                            for (let i_21: number = 0; i_21 < size_21; i_21++) {
                                const value_165: string = input.readString();
                                value_164.push(value_165);
                            }
                            input.readListEnd();
                            value_163.set(key_2, value_164);
                        }
                        input.readMapEnd();
                        _args.skippedPhotoIdsMap = value_163;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.totalCount !== undefined && _args.albums !== undefined) {
            return new TFetchAlbumsResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchAlbumsResponse from input");
        }
    }
}
export interface ITFetchAlbumSuggestionsRequestArgs {
    pageToken?: number | Int64;
    numRows?: number;
}
export class TFetchAlbumSuggestionsRequest {
    public pageToken?: Int64;
    public numRows?: number = 20;
    constructor(args?: ITFetchAlbumSuggestionsRequestArgs) {
        if (args != null && args.pageToken != null) {
            if (typeof args.pageToken === "number") {
                this.pageToken = new Int64(args.pageToken);
            }
            else {
                this.pageToken = args.pageToken;
            }
        }
        if (args != null && args.numRows != null) {
            this.numRows = args.numRows;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchAlbumSuggestionsRequest");
        if (this.pageToken != null) {
            output.writeFieldBegin("pageToken", thrift.Thrift.Type.I64, 1);
            output.writeI64(this.pageToken);
            output.writeFieldEnd();
        }
        if (this.numRows != null) {
            output.writeFieldBegin("numRows", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.numRows);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchAlbumSuggestionsRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_166: Int64 = input.readI64();
                        _args.pageToken = value_166;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_167: number = input.readI32();
                        _args.numRows = value_167;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchAlbumSuggestionsRequest(_args);
    }
}
export interface ITFetchAlbumSuggestionsResponseArgs {
    totalCount: number;
    albumSuggestions: Array<TAppPhoenixAlbumSuggestion>;
    nextPageToken?: string;
}
export class TFetchAlbumSuggestionsResponse {
    public totalCount: number;
    public albumSuggestions: Array<TAppPhoenixAlbumSuggestion>;
    public nextPageToken?: string;
    constructor(args: ITFetchAlbumSuggestionsResponseArgs) {
        if (args != null && args.totalCount != null) {
            this.totalCount = args.totalCount;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[totalCount] is unset!");
        }
        if (args != null && args.albumSuggestions != null) {
            this.albumSuggestions = args.albumSuggestions;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumSuggestions] is unset!");
        }
        if (args != null && args.nextPageToken != null) {
            this.nextPageToken = args.nextPageToken;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchAlbumSuggestionsResponse");
        if (this.totalCount != null) {
            output.writeFieldBegin("totalCount", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.totalCount);
            output.writeFieldEnd();
        }
        if (this.albumSuggestions != null) {
            output.writeFieldBegin("albumSuggestions", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.albumSuggestions.length);
            this.albumSuggestions.forEach((value_168: TAppPhoenixAlbumSuggestion): void => {
                value_168.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.nextPageToken != null) {
            output.writeFieldBegin("nextPageToken", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.nextPageToken);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchAlbumSuggestionsResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_169: number = input.readI32();
                        _args.totalCount = value_169;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_170: Array<TAppPhoenixAlbumSuggestion> = new Array<TAppPhoenixAlbumSuggestion>();
                        const metadata_22: thrift.TList = input.readListBegin();
                        const size_22: number = metadata_22.size;
                        for (let i_22: number = 0; i_22 < size_22; i_22++) {
                            const value_171: TAppPhoenixAlbumSuggestion = TAppPhoenixAlbumSuggestion.read(input);
                            value_170.push(value_171);
                        }
                        input.readListEnd();
                        _args.albumSuggestions = value_170;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_172: string = input.readString();
                        _args.nextPageToken = value_172;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.totalCount !== undefined && _args.albumSuggestions !== undefined) {
            return new TFetchAlbumSuggestionsResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchAlbumSuggestionsResponse from input");
        }
    }
}
export interface ITUpdateAlbumSuggestionRequestArgs {
    albumSuggestionUuid: string;
    status: TAppPhoenixAlbumSuggestionStatus;
}
export class TUpdateAlbumSuggestionRequest {
    public albumSuggestionUuid: string;
    public status: TAppPhoenixAlbumSuggestionStatus;
    constructor(args: ITUpdateAlbumSuggestionRequestArgs) {
        if (args != null && args.albumSuggestionUuid != null) {
            this.albumSuggestionUuid = args.albumSuggestionUuid;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumSuggestionUuid] is unset!");
        }
        if (args != null && args.status != null) {
            this.status = args.status;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[status] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateAlbumSuggestionRequest");
        if (this.albumSuggestionUuid != null) {
            output.writeFieldBegin("albumSuggestionUuid", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumSuggestionUuid);
            output.writeFieldEnd();
        }
        if (this.status != null) {
            output.writeFieldBegin("status", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.status);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateAlbumSuggestionRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_173: string = input.readString();
                        _args.albumSuggestionUuid = value_173;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_174: TAppPhoenixAlbumSuggestionStatus = input.readI32();
                        _args.status = value_174;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumSuggestionUuid !== undefined && _args.status !== undefined) {
            return new TUpdateAlbumSuggestionRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdateAlbumSuggestionRequest from input");
        }
    }
}
export interface ITUpdateAlbumSuggestionResponseArgs {
}
export class TUpdateAlbumSuggestionResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateAlbumSuggestionResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateAlbumSuggestionResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUpdateAlbumSuggestionResponse();
    }
}
export interface ITDeletePhotoRequestArgs {
    userId: string;
    photoId: string;
    albumId: string;
}
export class TDeletePhotoRequest {
    public userId: string;
    public photoId: string;
    public albumId: string;
    constructor(args: ITDeletePhotoRequestArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.photoId != null) {
            this.photoId = args.photoId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoId] is unset!");
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeletePhotoRequest");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.photoId != null) {
            output.writeFieldBegin("photoId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.photoId);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeletePhotoRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_175: string = input.readString();
                        _args.userId = value_175;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_176: string = input.readString();
                        _args.photoId = value_176;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_177: string = input.readString();
                        _args.albumId = value_177;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.photoId !== undefined && _args.albumId !== undefined) {
            return new TDeletePhotoRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDeletePhotoRequest from input");
        }
    }
}
export interface ITDeletePhotoResponseArgs {
}
export class TDeletePhotoResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeletePhotoResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeletePhotoResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TDeletePhotoResponse();
    }
}
export interface ITRenameAlbumRequestArgs {
    userId: string;
    albumId: string;
    title: string;
}
export class TRenameAlbumRequest {
    public userId: string;
    public albumId: string;
    public title: string;
    constructor(args: ITRenameAlbumRequestArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.title != null) {
            this.title = args.title;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[title] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TRenameAlbumRequest");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.title != null) {
            output.writeFieldBegin("title", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.title);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TRenameAlbumRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_178: string = input.readString();
                        _args.userId = value_178;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_179: string = input.readString();
                        _args.albumId = value_179;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_180: string = input.readString();
                        _args.title = value_180;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.albumId !== undefined && _args.title !== undefined) {
            return new TRenameAlbumRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TRenameAlbumRequest from input");
        }
    }
}
export interface ITRenameAlbumResponseArgs {
}
export class TRenameAlbumResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TRenameAlbumResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TRenameAlbumResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TRenameAlbumResponse();
    }
}
export interface ITJoinAlbumRequestArgs {
    userId: string;
    code: string;
    uploadMode?: TAppPhoenixPhotoUploadMode;
}
export class TJoinAlbumRequest {
    public userId: string;
    public code: string;
    public uploadMode?: TAppPhoenixPhotoUploadMode;
    constructor(args: ITJoinAlbumRequestArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.code != null) {
            this.code = args.code;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[code] is unset!");
        }
        if (args != null && args.uploadMode != null) {
            this.uploadMode = args.uploadMode;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TJoinAlbumRequest");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.code != null) {
            output.writeFieldBegin("code", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.code);
            output.writeFieldEnd();
        }
        if (this.uploadMode != null) {
            output.writeFieldBegin("uploadMode", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.uploadMode);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TJoinAlbumRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_181: string = input.readString();
                        _args.userId = value_181;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_182: string = input.readString();
                        _args.code = value_182;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_183: TAppPhoenixPhotoUploadMode = input.readI32();
                        _args.uploadMode = value_183;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.code !== undefined) {
            return new TJoinAlbumRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TJoinAlbumRequest from input");
        }
    }
}
export interface ITJoinAlbumResponseArgs {
    album?: TAppPhoenixAlbum;
}
export class TJoinAlbumResponse {
    public album?: TAppPhoenixAlbum;
    constructor(args?: ITJoinAlbumResponseArgs) {
        if (args != null && args.album != null) {
            this.album = args.album;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TJoinAlbumResponse");
        if (this.album != null) {
            output.writeFieldBegin("album", thrift.Thrift.Type.STRUCT, 1);
            this.album.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TJoinAlbumResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_184: TAppPhoenixAlbum = TAppPhoenixAlbum.read(input);
                        _args.album = value_184;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TJoinAlbumResponse(_args);
    }
}
export interface ITFetchAlbumMetaRequestArgs {
    fetchKey: TAppPhoenixFetchAlbumMetaKey;
}
export class TFetchAlbumMetaRequest {
    public fetchKey: TAppPhoenixFetchAlbumMetaKey;
    constructor(args: ITFetchAlbumMetaRequestArgs) {
        if (args != null && args.fetchKey != null) {
            this.fetchKey = args.fetchKey;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[fetchKey] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchAlbumMetaRequest");
        if (this.fetchKey != null) {
            output.writeFieldBegin("fetchKey", thrift.Thrift.Type.STRUCT, 1);
            this.fetchKey.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchAlbumMetaRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_185: TAppPhoenixFetchAlbumMetaKey = TAppPhoenixFetchAlbumMetaKey.read(input);
                        _args.fetchKey = value_185;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.fetchKey !== undefined) {
            return new TFetchAlbumMetaRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchAlbumMetaRequest from input");
        }
    }
}
export interface ITFetchAlbumMetaResponseArgs {
    albumMeta: TAppPhoenixAlbumMeta;
}
export class TFetchAlbumMetaResponse {
    public albumMeta: TAppPhoenixAlbumMeta;
    constructor(args: ITFetchAlbumMetaResponseArgs) {
        if (args != null && args.albumMeta != null) {
            this.albumMeta = args.albumMeta;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumMeta] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchAlbumMetaResponse");
        if (this.albumMeta != null) {
            output.writeFieldBegin("albumMeta", thrift.Thrift.Type.STRUCT, 1);
            this.albumMeta.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchAlbumMetaResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_186: TAppPhoenixAlbumMeta = TAppPhoenixAlbumMeta.read(input);
                        _args.albumMeta = value_186;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumMeta !== undefined) {
            return new TFetchAlbumMetaResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchAlbumMetaResponse from input");
        }
    }
}
export interface ITCreateAlbumRequestArgs {
    userId: string;
    albumMeta: TAppPhoenixAlbumMeta;
    uploadMode?: TAppPhoenixPhotoUploadMode;
}
export class TCreateAlbumRequest {
    public userId: string;
    public albumMeta: TAppPhoenixAlbumMeta;
    public uploadMode?: TAppPhoenixPhotoUploadMode;
    constructor(args: ITCreateAlbumRequestArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.albumMeta != null) {
            this.albumMeta = args.albumMeta;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumMeta] is unset!");
        }
        if (args != null && args.uploadMode != null) {
            this.uploadMode = args.uploadMode;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TCreateAlbumRequest");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.albumMeta != null) {
            output.writeFieldBegin("albumMeta", thrift.Thrift.Type.STRUCT, 2);
            this.albumMeta.write(output);
            output.writeFieldEnd();
        }
        if (this.uploadMode != null) {
            output.writeFieldBegin("uploadMode", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.uploadMode);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TCreateAlbumRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_187: string = input.readString();
                        _args.userId = value_187;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_188: TAppPhoenixAlbumMeta = TAppPhoenixAlbumMeta.read(input);
                        _args.albumMeta = value_188;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_189: TAppPhoenixPhotoUploadMode = input.readI32();
                        _args.uploadMode = value_189;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.albumMeta !== undefined) {
            return new TCreateAlbumRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TCreateAlbumRequest from input");
        }
    }
}
export interface ITCreateAlbumResponseArgs {
    album: TAppPhoenixAlbum;
}
export class TCreateAlbumResponse {
    public album: TAppPhoenixAlbum;
    constructor(args: ITCreateAlbumResponseArgs) {
        if (args != null && args.album != null) {
            this.album = args.album;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[album] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TCreateAlbumResponse");
        if (this.album != null) {
            output.writeFieldBegin("album", thrift.Thrift.Type.STRUCT, 1);
            this.album.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TCreateAlbumResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_190: TAppPhoenixAlbum = TAppPhoenixAlbum.read(input);
                        _args.album = value_190;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.album !== undefined) {
            return new TCreateAlbumResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TCreateAlbumResponse from input");
        }
    }
}
export interface ITAddPhotoReactionRequestArgs {
    reaction: TAppPhoenixReaction;
    photoId: string;
    albumId: string;
}
export class TAddPhotoReactionRequest {
    public reaction: TAppPhoenixReaction;
    public photoId: string;
    public albumId: string;
    constructor(args: ITAddPhotoReactionRequestArgs) {
        if (args != null && args.reaction != null) {
            this.reaction = args.reaction;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[reaction] is unset!");
        }
        if (args != null && args.photoId != null) {
            this.photoId = args.photoId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoId] is unset!");
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddPhotoReactionRequest");
        if (this.reaction != null) {
            output.writeFieldBegin("reaction", thrift.Thrift.Type.STRUCT, 1);
            this.reaction.write(output);
            output.writeFieldEnd();
        }
        if (this.photoId != null) {
            output.writeFieldBegin("photoId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.photoId);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddPhotoReactionRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_191: TAppPhoenixReaction = TAppPhoenixReaction.read(input);
                        _args.reaction = value_191;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_192: string = input.readString();
                        _args.photoId = value_192;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_193: string = input.readString();
                        _args.albumId = value_193;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.reaction !== undefined && _args.photoId !== undefined && _args.albumId !== undefined) {
            return new TAddPhotoReactionRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAddPhotoReactionRequest from input");
        }
    }
}
export interface ITAddPhotoReactionResponseArgs {
}
export class TAddPhotoReactionResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddPhotoReactionResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddPhotoReactionResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAddPhotoReactionResponse();
    }
}
export interface ITRemovePhotoReactionRequestArgs {
    reaction: TAppPhoenixReaction;
    photoId: string;
    albumId: string;
}
export class TRemovePhotoReactionRequest {
    public reaction: TAppPhoenixReaction;
    public photoId: string;
    public albumId: string;
    constructor(args: ITRemovePhotoReactionRequestArgs) {
        if (args != null && args.reaction != null) {
            this.reaction = args.reaction;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[reaction] is unset!");
        }
        if (args != null && args.photoId != null) {
            this.photoId = args.photoId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoId] is unset!");
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TRemovePhotoReactionRequest");
        if (this.reaction != null) {
            output.writeFieldBegin("reaction", thrift.Thrift.Type.STRUCT, 1);
            this.reaction.write(output);
            output.writeFieldEnd();
        }
        if (this.photoId != null) {
            output.writeFieldBegin("photoId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.photoId);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TRemovePhotoReactionRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_194: TAppPhoenixReaction = TAppPhoenixReaction.read(input);
                        _args.reaction = value_194;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_195: string = input.readString();
                        _args.photoId = value_195;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_196: string = input.readString();
                        _args.albumId = value_196;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.reaction !== undefined && _args.photoId !== undefined && _args.albumId !== undefined) {
            return new TRemovePhotoReactionRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TRemovePhotoReactionRequest from input");
        }
    }
}
export interface ITRemovePhotoReactionResponseArgs {
}
export class TRemovePhotoReactionResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TRemovePhotoReactionResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TRemovePhotoReactionResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TRemovePhotoReactionResponse();
    }
}
export interface ITAddAlbumReactionRequestArgs {
    reaction: TAppPhoenixReaction;
    albumId: string;
}
export class TAddAlbumReactionRequest {
    public reaction: TAppPhoenixReaction;
    public albumId: string;
    constructor(args: ITAddAlbumReactionRequestArgs) {
        if (args != null && args.reaction != null) {
            this.reaction = args.reaction;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[reaction] is unset!");
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddAlbumReactionRequest");
        if (this.reaction != null) {
            output.writeFieldBegin("reaction", thrift.Thrift.Type.STRUCT, 1);
            this.reaction.write(output);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddAlbumReactionRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_197: TAppPhoenixReaction = TAppPhoenixReaction.read(input);
                        _args.reaction = value_197;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_198: string = input.readString();
                        _args.albumId = value_198;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.reaction !== undefined && _args.albumId !== undefined) {
            return new TAddAlbumReactionRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAddAlbumReactionRequest from input");
        }
    }
}
export interface ITAddAlbumReactionResponseArgs {
}
export class TAddAlbumReactionResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddAlbumReactionResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddAlbumReactionResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAddAlbumReactionResponse();
    }
}
export interface ITUpdateAlbumActivityRequestArgs {
    albumId: string;
    apnsToken: string;
    activityToken: string;
}
export class TUpdateAlbumActivityRequest {
    public albumId: string;
    public apnsToken: string;
    public activityToken: string;
    constructor(args: ITUpdateAlbumActivityRequestArgs) {
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.apnsToken != null) {
            this.apnsToken = args.apnsToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[apnsToken] is unset!");
        }
        if (args != null && args.activityToken != null) {
            this.activityToken = args.activityToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[activityToken] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateAlbumActivityRequest");
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.apnsToken != null) {
            output.writeFieldBegin("apnsToken", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.apnsToken);
            output.writeFieldEnd();
        }
        if (this.activityToken != null) {
            output.writeFieldBegin("activityToken", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.activityToken);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateAlbumActivityRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_199: string = input.readString();
                        _args.albumId = value_199;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_200: string = input.readString();
                        _args.apnsToken = value_200;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_201: string = input.readString();
                        _args.activityToken = value_201;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined && _args.apnsToken !== undefined && _args.activityToken !== undefined) {
            return new TUpdateAlbumActivityRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdateAlbumActivityRequest from input");
        }
    }
}
export interface ITUpdateAlbumActivityResponseArgs {
}
export class TUpdateAlbumActivityResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateAlbumActivityResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateAlbumActivityResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUpdateAlbumActivityResponse();
    }
}
export interface ITRemoveAlbumReactionRequestArgs {
    reaction: TAppPhoenixReaction;
    albumId: string;
}
export class TRemoveAlbumReactionRequest {
    public reaction: TAppPhoenixReaction;
    public albumId: string;
    constructor(args: ITRemoveAlbumReactionRequestArgs) {
        if (args != null && args.reaction != null) {
            this.reaction = args.reaction;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[reaction] is unset!");
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TRemoveAlbumReactionRequest");
        if (this.reaction != null) {
            output.writeFieldBegin("reaction", thrift.Thrift.Type.STRUCT, 1);
            this.reaction.write(output);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TRemoveAlbumReactionRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_202: TAppPhoenixReaction = TAppPhoenixReaction.read(input);
                        _args.reaction = value_202;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_203: string = input.readString();
                        _args.albumId = value_203;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.reaction !== undefined && _args.albumId !== undefined) {
            return new TRemoveAlbumReactionRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TRemoveAlbumReactionRequest from input");
        }
    }
}
export interface ITRemoveAlbumReactionResponseArgs {
}
export class TRemoveAlbumReactionResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TRemoveAlbumReactionResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TRemoveAlbumReactionResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TRemoveAlbumReactionResponse();
    }
}
export interface ITLeaveAlbumRequestArgs {
    albumId: string;
}
export class TLeaveAlbumRequest {
    public albumId: string;
    constructor(args: ITLeaveAlbumRequestArgs) {
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TLeaveAlbumRequest");
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TLeaveAlbumRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_204: string = input.readString();
                        _args.albumId = value_204;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined) {
            return new TLeaveAlbumRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TLeaveAlbumRequest from input");
        }
    }
}
export interface ITLeaveAlbumResponseArgs {
}
export class TLeaveAlbumResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TLeaveAlbumResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TLeaveAlbumResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TLeaveAlbumResponse();
    }
}
export interface ITDeleteAlbumRequestArgs {
    albumId: string;
}
export class TDeleteAlbumRequest {
    public albumId: string;
    constructor(args: ITDeleteAlbumRequestArgs) {
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeleteAlbumRequest");
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeleteAlbumRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_205: string = input.readString();
                        _args.albumId = value_205;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined) {
            return new TDeleteAlbumRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDeleteAlbumRequest from input");
        }
    }
}
export interface ITDeleteAlbumResponseArgs {
}
export class TDeleteAlbumResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeleteAlbumResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeleteAlbumResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TDeleteAlbumResponse();
    }
}
export interface ITAddAlbumCommentRequestArgs {
    comment: TAppPhoenixComment;
    albumId: string;
}
export class TAddAlbumCommentRequest {
    public comment: TAppPhoenixComment;
    public albumId: string;
    constructor(args: ITAddAlbumCommentRequestArgs) {
        if (args != null && args.comment != null) {
            this.comment = args.comment;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[comment] is unset!");
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddAlbumCommentRequest");
        if (this.comment != null) {
            output.writeFieldBegin("comment", thrift.Thrift.Type.STRUCT, 1);
            this.comment.write(output);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddAlbumCommentRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_206: TAppPhoenixComment = TAppPhoenixComment.read(input);
                        _args.comment = value_206;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_207: string = input.readString();
                        _args.albumId = value_207;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.comment !== undefined && _args.albumId !== undefined) {
            return new TAddAlbumCommentRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAddAlbumCommentRequest from input");
        }
    }
}
export interface ITAddAlbumCommentResponseArgs {
}
export class TAddAlbumCommentResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddAlbumCommentResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddAlbumCommentResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAddAlbumCommentResponse();
    }
}
export interface ITEditAlbumCommentRequestArgs {
    comment: TAppPhoenixComment;
}
export class TEditAlbumCommentRequest {
    public comment: TAppPhoenixComment;
    constructor(args: ITEditAlbumCommentRequestArgs) {
        if (args != null && args.comment != null) {
            this.comment = args.comment;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[comment] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TEditAlbumCommentRequest");
        if (this.comment != null) {
            output.writeFieldBegin("comment", thrift.Thrift.Type.STRUCT, 1);
            this.comment.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TEditAlbumCommentRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_208: TAppPhoenixComment = TAppPhoenixComment.read(input);
                        _args.comment = value_208;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.comment !== undefined) {
            return new TEditAlbumCommentRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TEditAlbumCommentRequest from input");
        }
    }
}
export interface ITEditAlbumCommentResponseArgs {
}
export class TEditAlbumCommentResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TEditAlbumCommentResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TEditAlbumCommentResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TEditAlbumCommentResponse();
    }
}
export interface ITDeleteAlbumCommentRequestArgs {
    commentId: string;
}
export class TDeleteAlbumCommentRequest {
    public commentId: string;
    constructor(args: ITDeleteAlbumCommentRequestArgs) {
        if (args != null && args.commentId != null) {
            this.commentId = args.commentId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[commentId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeleteAlbumCommentRequest");
        if (this.commentId != null) {
            output.writeFieldBegin("commentId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.commentId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeleteAlbumCommentRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_209: string = input.readString();
                        _args.commentId = value_209;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.commentId !== undefined) {
            return new TDeleteAlbumCommentRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDeleteAlbumCommentRequest from input");
        }
    }
}
export interface ITDeleteAlbumCommentResponseArgs {
}
export class TDeleteAlbumCommentResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeleteAlbumCommentResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeleteAlbumCommentResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TDeleteAlbumCommentResponse();
    }
}
export interface ITAddPhotoCommentRequestArgs {
    comment: TAppPhoenixComment;
    photoId: string;
    albumId: string;
}
export class TAddPhotoCommentRequest {
    public comment: TAppPhoenixComment;
    public photoId: string;
    public albumId: string;
    constructor(args: ITAddPhotoCommentRequestArgs) {
        if (args != null && args.comment != null) {
            this.comment = args.comment;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[comment] is unset!");
        }
        if (args != null && args.photoId != null) {
            this.photoId = args.photoId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoId] is unset!");
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddPhotoCommentRequest");
        if (this.comment != null) {
            output.writeFieldBegin("comment", thrift.Thrift.Type.STRUCT, 1);
            this.comment.write(output);
            output.writeFieldEnd();
        }
        if (this.photoId != null) {
            output.writeFieldBegin("photoId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.photoId);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddPhotoCommentRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_210: TAppPhoenixComment = TAppPhoenixComment.read(input);
                        _args.comment = value_210;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_211: string = input.readString();
                        _args.photoId = value_211;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_212: string = input.readString();
                        _args.albumId = value_212;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.comment !== undefined && _args.photoId !== undefined && _args.albumId !== undefined) {
            return new TAddPhotoCommentRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAddPhotoCommentRequest from input");
        }
    }
}
export interface ITAddPhotoCommentResponseArgs {
}
export class TAddPhotoCommentResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddPhotoCommentResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddPhotoCommentResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAddPhotoCommentResponse();
    }
}
export interface ITEditPhotoCommentRequestArgs {
    comment: TAppPhoenixComment;
}
export class TEditPhotoCommentRequest {
    public comment: TAppPhoenixComment;
    constructor(args: ITEditPhotoCommentRequestArgs) {
        if (args != null && args.comment != null) {
            this.comment = args.comment;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[comment] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TEditPhotoCommentRequest");
        if (this.comment != null) {
            output.writeFieldBegin("comment", thrift.Thrift.Type.STRUCT, 1);
            this.comment.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TEditPhotoCommentRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_213: TAppPhoenixComment = TAppPhoenixComment.read(input);
                        _args.comment = value_213;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.comment !== undefined) {
            return new TEditPhotoCommentRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TEditPhotoCommentRequest from input");
        }
    }
}
export interface ITEditPhotoCommentResponseArgs {
}
export class TEditPhotoCommentResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TEditPhotoCommentResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TEditPhotoCommentResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TEditPhotoCommentResponse();
    }
}
export interface ITDeletePhotoCommentRequestArgs {
    commentId: string;
}
export class TDeletePhotoCommentRequest {
    public commentId: string;
    constructor(args: ITDeletePhotoCommentRequestArgs) {
        if (args != null && args.commentId != null) {
            this.commentId = args.commentId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[commentId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeletePhotoCommentRequest");
        if (this.commentId != null) {
            output.writeFieldBegin("commentId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.commentId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeletePhotoCommentRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_214: string = input.readString();
                        _args.commentId = value_214;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.commentId !== undefined) {
            return new TDeletePhotoCommentRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDeletePhotoCommentRequest from input");
        }
    }
}
export interface ITDeletePhotoCommentResponseArgs {
}
export class TDeletePhotoCommentResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeletePhotoCommentResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeletePhotoCommentResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TDeletePhotoCommentResponse();
    }
}
export interface ITSetKeyClusterPhotoRequestArgs {
    albumId: string;
    photoId: string;
}
export class TSetKeyClusterPhotoRequest {
    public albumId: string;
    public photoId: string;
    constructor(args: ITSetKeyClusterPhotoRequestArgs) {
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.photoId != null) {
            this.photoId = args.photoId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSetKeyClusterPhotoRequest");
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.photoId != null) {
            output.writeFieldBegin("photoId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.photoId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSetKeyClusterPhotoRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_215: string = input.readString();
                        _args.albumId = value_215;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_216: string = input.readString();
                        _args.photoId = value_216;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined && _args.photoId !== undefined) {
            return new TSetKeyClusterPhotoRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TSetKeyClusterPhotoRequest from input");
        }
    }
}
export interface ITSetKeyClusterPhotoResponseArgs {
}
export class TSetKeyClusterPhotoResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSetKeyClusterPhotoResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSetKeyClusterPhotoResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TSetKeyClusterPhotoResponse();
    }
}
export interface ITSetAlbumCoverRequestArgs {
    albumId: string;
    photoId: string;
}
export class TSetAlbumCoverRequest {
    public albumId: string;
    public photoId: string;
    constructor(args: ITSetAlbumCoverRequestArgs) {
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.photoId != null) {
            this.photoId = args.photoId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSetAlbumCoverRequest");
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.photoId != null) {
            output.writeFieldBegin("photoId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.photoId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSetAlbumCoverRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_217: string = input.readString();
                        _args.albumId = value_217;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_218: string = input.readString();
                        _args.photoId = value_218;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined && _args.photoId !== undefined) {
            return new TSetAlbumCoverRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TSetAlbumCoverRequest from input");
        }
    }
}
export interface ITSetAlbumCoverResponseArgs {
}
export class TSetAlbumCoverResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSetAlbumCoverResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSetAlbumCoverResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TSetAlbumCoverResponse();
    }
}
export interface ITAddPhotosToAlbumRequestArgs {
    albumId: string;
    photoIds: Array<string>;
    shouldExpandBoundary?: boolean;
}
export class TAddPhotosToAlbumRequest {
    public albumId: string;
    public photoIds: Array<string>;
    public shouldExpandBoundary?: boolean;
    constructor(args: ITAddPhotosToAlbumRequestArgs) {
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.photoIds != null) {
            this.photoIds = args.photoIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoIds] is unset!");
        }
        if (args != null && args.shouldExpandBoundary != null) {
            this.shouldExpandBoundary = args.shouldExpandBoundary;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddPhotosToAlbumRequest");
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.photoIds != null) {
            output.writeFieldBegin("photoIds", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.photoIds.length);
            this.photoIds.forEach((value_219: string): void => {
                output.writeString(value_219);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.shouldExpandBoundary != null) {
            output.writeFieldBegin("shouldExpandBoundary", thrift.Thrift.Type.BOOL, 3);
            output.writeBool(this.shouldExpandBoundary);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddPhotosToAlbumRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_220: string = input.readString();
                        _args.albumId = value_220;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_221: Array<string> = new Array<string>();
                        const metadata_23: thrift.TList = input.readListBegin();
                        const size_23: number = metadata_23.size;
                        for (let i_23: number = 0; i_23 < size_23; i_23++) {
                            const value_222: string = input.readString();
                            value_221.push(value_222);
                        }
                        input.readListEnd();
                        _args.photoIds = value_221;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_223: boolean = input.readBool();
                        _args.shouldExpandBoundary = value_223;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined && _args.photoIds !== undefined) {
            return new TAddPhotosToAlbumRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAddPhotosToAlbumRequest from input");
        }
    }
}
export interface ITAddPhotosToAlbumResponseArgs {
}
export class TAddPhotosToAlbumResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddPhotosToAlbumResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddPhotosToAlbumResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAddPhotosToAlbumResponse();
    }
}
export interface ITExtendAlbumRequestArgs {
    albumId: string;
    timespanInMinute: number;
}
export class TExtendAlbumRequest {
    public albumId: string;
    public timespanInMinute: number;
    constructor(args: ITExtendAlbumRequestArgs) {
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.timespanInMinute != null) {
            this.timespanInMinute = args.timespanInMinute;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[timespanInMinute] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TExtendAlbumRequest");
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.timespanInMinute != null) {
            output.writeFieldBegin("timespanInMinute", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.timespanInMinute);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TExtendAlbumRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_224: string = input.readString();
                        _args.albumId = value_224;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_225: number = input.readI32();
                        _args.timespanInMinute = value_225;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined && _args.timespanInMinute !== undefined) {
            return new TExtendAlbumRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TExtendAlbumRequest from input");
        }
    }
}
export interface ITExtendAlbumResponseArgs {
}
export class TExtendAlbumResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TExtendAlbumResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TExtendAlbumResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TExtendAlbumResponse();
    }
}
export interface ITUploadPhotoMetaRequestArgs {
    photoMetaList: Array<TAppPhoenixPhotoMeta>;
}
export class TUploadPhotoMetaRequest {
    public photoMetaList: Array<TAppPhoenixPhotoMeta>;
    constructor(args: ITUploadPhotoMetaRequestArgs) {
        if (args != null && args.photoMetaList != null) {
            this.photoMetaList = args.photoMetaList;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoMetaList] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUploadPhotoMetaRequest");
        if (this.photoMetaList != null) {
            output.writeFieldBegin("photoMetaList", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.photoMetaList.length);
            this.photoMetaList.forEach((value_226: TAppPhoenixPhotoMeta): void => {
                value_226.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUploadPhotoMetaRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_227: Array<TAppPhoenixPhotoMeta> = new Array<TAppPhoenixPhotoMeta>();
                        const metadata_24: thrift.TList = input.readListBegin();
                        const size_24: number = metadata_24.size;
                        for (let i_24: number = 0; i_24 < size_24; i_24++) {
                            const value_228: TAppPhoenixPhotoMeta = TAppPhoenixPhotoMeta.read(input);
                            value_227.push(value_228);
                        }
                        input.readListEnd();
                        _args.photoMetaList = value_227;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.photoMetaList !== undefined) {
            return new TUploadPhotoMetaRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUploadPhotoMetaRequest from input");
        }
    }
}
export interface ITUploadPhotoMetaResponseArgs {
}
export class TUploadPhotoMetaResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUploadPhotoMetaResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUploadPhotoMetaResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUploadPhotoMetaResponse();
    }
}
export interface ITFetchPhoenixHomepageRequestArgs {
}
export class TFetchPhoenixHomepageRequest {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchPhoenixHomepageRequest");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchPhoenixHomepageRequest {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchPhoenixHomepageRequest();
    }
}
export interface ITFetchPhoenixHomepageResponseArgs {
    items: Array<TAppPhoenixHomepageItem>;
}
export class TFetchPhoenixHomepageResponse {
    public items: Array<TAppPhoenixHomepageItem>;
    constructor(args: ITFetchPhoenixHomepageResponseArgs) {
        if (args != null && args.items != null) {
            this.items = args.items;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[items] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchPhoenixHomepageResponse");
        if (this.items != null) {
            output.writeFieldBegin("items", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.items.length);
            this.items.forEach((value_229: TAppPhoenixHomepageItem): void => {
                value_229.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchPhoenixHomepageResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_230: Array<TAppPhoenixHomepageItem> = new Array<TAppPhoenixHomepageItem>();
                        const metadata_25: thrift.TList = input.readListBegin();
                        const size_25: number = metadata_25.size;
                        for (let i_25: number = 0; i_25 < size_25; i_25++) {
                            const value_231: TAppPhoenixHomepageItem = TAppPhoenixHomepageItem.read(input);
                            value_230.push(value_231);
                        }
                        input.readListEnd();
                        _args.items = value_230;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.items !== undefined) {
            return new TFetchPhoenixHomepageResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchPhoenixHomepageResponse from input");
        }
    }
}
export interface ITAppPhoenixHomepageClusterArgs {
    photos?: Array<TAppPhoenixPhotoMeta>;
    albumId: string;
    albumTitle: string;
    latestUpdateType?: TAppPhoenixHomepageClusterUpdateType;
}
export class TAppPhoenixHomepageCluster {
    public photos?: Array<TAppPhoenixPhotoMeta>;
    public albumId: string;
    public albumTitle: string;
    public latestUpdateType?: TAppPhoenixHomepageClusterUpdateType;
    constructor(args: ITAppPhoenixHomepageClusterArgs) {
        if (args != null && args.photos != null) {
            this.photos = args.photos;
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.albumTitle != null) {
            this.albumTitle = args.albumTitle;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumTitle] is unset!");
        }
        if (args != null && args.latestUpdateType != null) {
            this.latestUpdateType = args.latestUpdateType;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixHomepageCluster");
        if (this.photos != null) {
            output.writeFieldBegin("photos", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.photos.length);
            this.photos.forEach((value_232: TAppPhoenixPhotoMeta): void => {
                value_232.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.albumTitle != null) {
            output.writeFieldBegin("albumTitle", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.albumTitle);
            output.writeFieldEnd();
        }
        if (this.latestUpdateType != null) {
            output.writeFieldBegin("latestUpdateType", thrift.Thrift.Type.STRUCT, 4);
            this.latestUpdateType.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixHomepageCluster {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_233: Array<TAppPhoenixPhotoMeta> = new Array<TAppPhoenixPhotoMeta>();
                        const metadata_26: thrift.TList = input.readListBegin();
                        const size_26: number = metadata_26.size;
                        for (let i_26: number = 0; i_26 < size_26; i_26++) {
                            const value_234: TAppPhoenixPhotoMeta = TAppPhoenixPhotoMeta.read(input);
                            value_233.push(value_234);
                        }
                        input.readListEnd();
                        _args.photos = value_233;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_235: string = input.readString();
                        _args.albumId = value_235;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_236: string = input.readString();
                        _args.albumTitle = value_236;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_237: TAppPhoenixHomepageClusterUpdateType = TAppPhoenixHomepageClusterUpdateType.read(input);
                        _args.latestUpdateType = value_237;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined && _args.albumTitle !== undefined) {
            return new TAppPhoenixHomepageCluster(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixHomepageCluster from input");
        }
    }
}
export interface ITAppPhoenixHomepageAlbumArgs {
    albumMeta: TAppPhoenixAlbumMeta;
}
export class TAppPhoenixHomepageAlbum {
    public albumMeta: TAppPhoenixAlbumMeta;
    constructor(args: ITAppPhoenixHomepageAlbumArgs) {
        if (args != null && args.albumMeta != null) {
            this.albumMeta = args.albumMeta;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumMeta] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixHomepageAlbum");
        if (this.albumMeta != null) {
            output.writeFieldBegin("albumMeta", thrift.Thrift.Type.STRUCT, 1);
            this.albumMeta.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixHomepageAlbum {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_238: TAppPhoenixAlbumMeta = TAppPhoenixAlbumMeta.read(input);
                        _args.albumMeta = value_238;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumMeta !== undefined) {
            return new TAppPhoenixHomepageAlbum(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixHomepageAlbum from input");
        }
    }
}
export interface ITAppPhoenixHomepageAlbumSuggestionArgs {
    albumSuggestion: TAppPhoenixAlbumSuggestion;
}
export class TAppPhoenixHomepageAlbumSuggestion {
    public albumSuggestion: TAppPhoenixAlbumSuggestion;
    constructor(args: ITAppPhoenixHomepageAlbumSuggestionArgs) {
        if (args != null && args.albumSuggestion != null) {
            this.albumSuggestion = args.albumSuggestion;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumSuggestion] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixHomepageAlbumSuggestion");
        if (this.albumSuggestion != null) {
            output.writeFieldBegin("albumSuggestion", thrift.Thrift.Type.STRUCT, 1);
            this.albumSuggestion.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixHomepageAlbumSuggestion {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_239: TAppPhoenixAlbumSuggestion = TAppPhoenixAlbumSuggestion.read(input);
                        _args.albumSuggestion = value_239;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumSuggestion !== undefined) {
            return new TAppPhoenixHomepageAlbumSuggestion(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixHomepageAlbumSuggestion from input");
        }
    }
}
export interface ITAppPhoenixHomepagePhotosSuggestionArgs {
    albumMeta: TAppPhoenixAlbumMeta;
    photoIds: Array<string>;
}
export class TAppPhoenixHomepagePhotosSuggestion {
    public albumMeta: TAppPhoenixAlbumMeta;
    public photoIds: Array<string>;
    constructor(args: ITAppPhoenixHomepagePhotosSuggestionArgs) {
        if (args != null && args.albumMeta != null) {
            this.albumMeta = args.albumMeta;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumMeta] is unset!");
        }
        if (args != null && args.photoIds != null) {
            this.photoIds = args.photoIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoIds] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixHomepagePhotosSuggestion");
        if (this.albumMeta != null) {
            output.writeFieldBegin("albumMeta", thrift.Thrift.Type.STRUCT, 1);
            this.albumMeta.write(output);
            output.writeFieldEnd();
        }
        if (this.photoIds != null) {
            output.writeFieldBegin("photoIds", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.photoIds.length);
            this.photoIds.forEach((value_240: string): void => {
                output.writeString(value_240);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixHomepagePhotosSuggestion {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_241: TAppPhoenixAlbumMeta = TAppPhoenixAlbumMeta.read(input);
                        _args.albumMeta = value_241;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_242: Array<string> = new Array<string>();
                        const metadata_27: thrift.TList = input.readListBegin();
                        const size_27: number = metadata_27.size;
                        for (let i_27: number = 0; i_27 < size_27; i_27++) {
                            const value_243: string = input.readString();
                            value_242.push(value_243);
                        }
                        input.readListEnd();
                        _args.photoIds = value_242;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumMeta !== undefined && _args.photoIds !== undefined) {
            return new TAppPhoenixHomepagePhotosSuggestion(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixHomepagePhotosSuggestion from input");
        }
    }
}
export interface ITAppPhoenixHomepageAlbumShareSuggestionArgs {
    albumTitle: string;
    albumId: string;
    peopleToInvite: Array<TAppPhoenixAlbumFace>;
}
export class TAppPhoenixHomepageAlbumShareSuggestion {
    public albumTitle: string;
    public albumId: string;
    public peopleToInvite: Array<TAppPhoenixAlbumFace>;
    constructor(args: ITAppPhoenixHomepageAlbumShareSuggestionArgs) {
        if (args != null && args.albumTitle != null) {
            this.albumTitle = args.albumTitle;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumTitle] is unset!");
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.peopleToInvite != null) {
            this.peopleToInvite = args.peopleToInvite;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[peopleToInvite] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixHomepageAlbumShareSuggestion");
        if (this.albumTitle != null) {
            output.writeFieldBegin("albumTitle", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumTitle);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.peopleToInvite != null) {
            output.writeFieldBegin("peopleToInvite", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.peopleToInvite.length);
            this.peopleToInvite.forEach((value_244: TAppPhoenixAlbumFace): void => {
                value_244.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixHomepageAlbumShareSuggestion {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_245: string = input.readString();
                        _args.albumTitle = value_245;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_246: string = input.readString();
                        _args.albumId = value_246;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_247: Array<TAppPhoenixAlbumFace> = new Array<TAppPhoenixAlbumFace>();
                        const metadata_28: thrift.TList = input.readListBegin();
                        const size_28: number = metadata_28.size;
                        for (let i_28: number = 0; i_28 < size_28; i_28++) {
                            const value_248: TAppPhoenixAlbumFace = TAppPhoenixAlbumFace.read(input);
                            value_247.push(value_248);
                        }
                        input.readListEnd();
                        _args.peopleToInvite = value_247;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumTitle !== undefined && _args.albumId !== undefined && _args.peopleToInvite !== undefined) {
            return new TAppPhoenixHomepageAlbumShareSuggestion(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixHomepageAlbumShareSuggestion from input");
        }
    }
}
export interface ITAppPhoenixHomepageAlbumFaceTagSuggestionArgs {
    albumTitle: string;
    albumId: string;
    peopleToTag: Array<TAppPhoenixAlbumFace>;
}
export class TAppPhoenixHomepageAlbumFaceTagSuggestion {
    public albumTitle: string;
    public albumId: string;
    public peopleToTag: Array<TAppPhoenixAlbumFace>;
    constructor(args: ITAppPhoenixHomepageAlbumFaceTagSuggestionArgs) {
        if (args != null && args.albumTitle != null) {
            this.albumTitle = args.albumTitle;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumTitle] is unset!");
        }
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.peopleToTag != null) {
            this.peopleToTag = args.peopleToTag;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[peopleToTag] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixHomepageAlbumFaceTagSuggestion");
        if (this.albumTitle != null) {
            output.writeFieldBegin("albumTitle", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumTitle);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.peopleToTag != null) {
            output.writeFieldBegin("peopleToTag", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.peopleToTag.length);
            this.peopleToTag.forEach((value_249: TAppPhoenixAlbumFace): void => {
                value_249.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixHomepageAlbumFaceTagSuggestion {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_250: string = input.readString();
                        _args.albumTitle = value_250;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_251: string = input.readString();
                        _args.albumId = value_251;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_252: Array<TAppPhoenixAlbumFace> = new Array<TAppPhoenixAlbumFace>();
                        const metadata_29: thrift.TList = input.readListBegin();
                        const size_29: number = metadata_29.size;
                        for (let i_29: number = 0; i_29 < size_29; i_29++) {
                            const value_253: TAppPhoenixAlbumFace = TAppPhoenixAlbumFace.read(input);
                            value_252.push(value_253);
                        }
                        input.readListEnd();
                        _args.peopleToTag = value_252;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumTitle !== undefined && _args.albumId !== undefined && _args.peopleToTag !== undefined) {
            return new TAppPhoenixHomepageAlbumFaceTagSuggestion(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixHomepageAlbumFaceTagSuggestion from input");
        }
    }
}
export interface ITChangeAlbumPhotoUploadModeRequestArgs {
    albumId: string;
    uploadMode: TAppPhoenixPhotoUploadMode;
}
export class TChangeAlbumPhotoUploadModeRequest {
    public albumId: string;
    public uploadMode: TAppPhoenixPhotoUploadMode;
    constructor(args: ITChangeAlbumPhotoUploadModeRequestArgs) {
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.uploadMode != null) {
            this.uploadMode = args.uploadMode;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[uploadMode] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TChangeAlbumPhotoUploadModeRequest");
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.uploadMode != null) {
            output.writeFieldBegin("uploadMode", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.uploadMode);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TChangeAlbumPhotoUploadModeRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_254: string = input.readString();
                        _args.albumId = value_254;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_255: TAppPhoenixPhotoUploadMode = input.readI32();
                        _args.uploadMode = value_255;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined && _args.uploadMode !== undefined) {
            return new TChangeAlbumPhotoUploadModeRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TChangeAlbumPhotoUploadModeRequest from input");
        }
    }
}
export interface ITChangeAlbumPhotoUploadModeResponseArgs {
}
export class TChangeAlbumPhotoUploadModeResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TChangeAlbumPhotoUploadModeResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TChangeAlbumPhotoUploadModeResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TChangeAlbumPhotoUploadModeResponse();
    }
}
export interface ITFetchNotificationsPageRequestArgs {
    pageToken: string;
}
export class TFetchNotificationsPageRequest {
    public pageToken: string;
    constructor(args: ITFetchNotificationsPageRequestArgs) {
        if (args != null && args.pageToken != null) {
            this.pageToken = args.pageToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[pageToken] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchNotificationsPageRequest");
        if (this.pageToken != null) {
            output.writeFieldBegin("pageToken", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.pageToken);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchNotificationsPageRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_256: string = input.readString();
                        _args.pageToken = value_256;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.pageToken !== undefined) {
            return new TFetchNotificationsPageRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchNotificationsPageRequest from input");
        }
    }
}
export interface ITFetchNotificationsPageResponseArgs {
    items: Array<TAppPhoenixNotificationPageItem>;
    pageToken: string;
    hasMore: boolean;
}
export class TFetchNotificationsPageResponse {
    public items: Array<TAppPhoenixNotificationPageItem>;
    public pageToken: string;
    public hasMore: boolean;
    constructor(args: ITFetchNotificationsPageResponseArgs) {
        if (args != null && args.items != null) {
            this.items = args.items;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[items] is unset!");
        }
        if (args != null && args.pageToken != null) {
            this.pageToken = args.pageToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[pageToken] is unset!");
        }
        if (args != null && args.hasMore != null) {
            this.hasMore = args.hasMore;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[hasMore] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchNotificationsPageResponse");
        if (this.items != null) {
            output.writeFieldBegin("items", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.items.length);
            this.items.forEach((value_257: TAppPhoenixNotificationPageItem): void => {
                value_257.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.pageToken != null) {
            output.writeFieldBegin("pageToken", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.pageToken);
            output.writeFieldEnd();
        }
        if (this.hasMore != null) {
            output.writeFieldBegin("hasMore", thrift.Thrift.Type.BOOL, 3);
            output.writeBool(this.hasMore);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchNotificationsPageResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_258: Array<TAppPhoenixNotificationPageItem> = new Array<TAppPhoenixNotificationPageItem>();
                        const metadata_30: thrift.TList = input.readListBegin();
                        const size_30: number = metadata_30.size;
                        for (let i_30: number = 0; i_30 < size_30; i_30++) {
                            const value_259: TAppPhoenixNotificationPageItem = TAppPhoenixNotificationPageItem.read(input);
                            value_258.push(value_259);
                        }
                        input.readListEnd();
                        _args.items = value_258;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_260: string = input.readString();
                        _args.pageToken = value_260;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_261: boolean = input.readBool();
                        _args.hasMore = value_261;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.items !== undefined && _args.pageToken !== undefined && _args.hasMore !== undefined) {
            return new TFetchNotificationsPageResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchNotificationsPageResponse from input");
        }
    }
}
export interface ITAppPhoenixReactionNotificationArgs {
    photo: TAppPhoenixPhotoMeta;
    albumMeta: TAppPhoenixAlbumMeta;
    reaction: TAppPhoenixReaction;
    sender: TAppPhoenixUser;
}
export class TAppPhoenixReactionNotification {
    public photo: TAppPhoenixPhotoMeta;
    public albumMeta: TAppPhoenixAlbumMeta;
    public reaction: TAppPhoenixReaction;
    public sender: TAppPhoenixUser;
    constructor(args: ITAppPhoenixReactionNotificationArgs) {
        if (args != null && args.photo != null) {
            this.photo = args.photo;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photo] is unset!");
        }
        if (args != null && args.albumMeta != null) {
            this.albumMeta = args.albumMeta;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumMeta] is unset!");
        }
        if (args != null && args.reaction != null) {
            this.reaction = args.reaction;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[reaction] is unset!");
        }
        if (args != null && args.sender != null) {
            this.sender = args.sender;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sender] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixReactionNotification");
        if (this.photo != null) {
            output.writeFieldBegin("photo", thrift.Thrift.Type.STRUCT, 1);
            this.photo.write(output);
            output.writeFieldEnd();
        }
        if (this.albumMeta != null) {
            output.writeFieldBegin("albumMeta", thrift.Thrift.Type.STRUCT, 2);
            this.albumMeta.write(output);
            output.writeFieldEnd();
        }
        if (this.reaction != null) {
            output.writeFieldBegin("reaction", thrift.Thrift.Type.STRUCT, 3);
            this.reaction.write(output);
            output.writeFieldEnd();
        }
        if (this.sender != null) {
            output.writeFieldBegin("sender", thrift.Thrift.Type.STRUCT, 4);
            this.sender.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixReactionNotification {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_262: TAppPhoenixPhotoMeta = TAppPhoenixPhotoMeta.read(input);
                        _args.photo = value_262;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_263: TAppPhoenixAlbumMeta = TAppPhoenixAlbumMeta.read(input);
                        _args.albumMeta = value_263;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_264: TAppPhoenixReaction = TAppPhoenixReaction.read(input);
                        _args.reaction = value_264;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_265: TAppPhoenixUser = TAppPhoenixUser.read(input);
                        _args.sender = value_265;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.photo !== undefined && _args.albumMeta !== undefined && _args.reaction !== undefined && _args.sender !== undefined) {
            return new TAppPhoenixReactionNotification(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixReactionNotification from input");
        }
    }
}
export interface ITAppPhoenixCommentNotificationArgs {
    photo: TAppPhoenixPhotoMeta;
    albumMeta: TAppPhoenixAlbumMeta;
    comment: TAppPhoenixComment;
    sender: TAppPhoenixUser;
}
export class TAppPhoenixCommentNotification {
    public photo: TAppPhoenixPhotoMeta;
    public albumMeta: TAppPhoenixAlbumMeta;
    public comment: TAppPhoenixComment;
    public sender: TAppPhoenixUser;
    constructor(args: ITAppPhoenixCommentNotificationArgs) {
        if (args != null && args.photo != null) {
            this.photo = args.photo;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photo] is unset!");
        }
        if (args != null && args.albumMeta != null) {
            this.albumMeta = args.albumMeta;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumMeta] is unset!");
        }
        if (args != null && args.comment != null) {
            this.comment = args.comment;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[comment] is unset!");
        }
        if (args != null && args.sender != null) {
            this.sender = args.sender;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sender] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixCommentNotification");
        if (this.photo != null) {
            output.writeFieldBegin("photo", thrift.Thrift.Type.STRUCT, 1);
            this.photo.write(output);
            output.writeFieldEnd();
        }
        if (this.albumMeta != null) {
            output.writeFieldBegin("albumMeta", thrift.Thrift.Type.STRUCT, 2);
            this.albumMeta.write(output);
            output.writeFieldEnd();
        }
        if (this.comment != null) {
            output.writeFieldBegin("comment", thrift.Thrift.Type.STRUCT, 3);
            this.comment.write(output);
            output.writeFieldEnd();
        }
        if (this.sender != null) {
            output.writeFieldBegin("sender", thrift.Thrift.Type.STRUCT, 4);
            this.sender.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixCommentNotification {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_266: TAppPhoenixPhotoMeta = TAppPhoenixPhotoMeta.read(input);
                        _args.photo = value_266;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_267: TAppPhoenixAlbumMeta = TAppPhoenixAlbumMeta.read(input);
                        _args.albumMeta = value_267;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_268: TAppPhoenixComment = TAppPhoenixComment.read(input);
                        _args.comment = value_268;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_269: TAppPhoenixUser = TAppPhoenixUser.read(input);
                        _args.sender = value_269;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.photo !== undefined && _args.albumMeta !== undefined && _args.comment !== undefined && _args.sender !== undefined) {
            return new TAppPhoenixCommentNotification(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixCommentNotification from input");
        }
    }
}
export interface ITAppPhoenixAlbumMemberArgs {
    member: TAppPhoenixUser;
    albumMeta: TAppPhoenixAlbumMeta;
    joinTs: number | Int64;
}
export class TAppPhoenixAlbumMember {
    public member: TAppPhoenixUser;
    public albumMeta: TAppPhoenixAlbumMeta;
    public joinTs: Int64;
    constructor(args: ITAppPhoenixAlbumMemberArgs) {
        if (args != null && args.member != null) {
            this.member = args.member;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[member] is unset!");
        }
        if (args != null && args.albumMeta != null) {
            this.albumMeta = args.albumMeta;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumMeta] is unset!");
        }
        if (args != null && args.joinTs != null) {
            if (typeof args.joinTs === "number") {
                this.joinTs = new Int64(args.joinTs);
            }
            else {
                this.joinTs = args.joinTs;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[joinTs] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixAlbumMember");
        if (this.member != null) {
            output.writeFieldBegin("member", thrift.Thrift.Type.STRUCT, 1);
            this.member.write(output);
            output.writeFieldEnd();
        }
        if (this.albumMeta != null) {
            output.writeFieldBegin("albumMeta", thrift.Thrift.Type.STRUCT, 2);
            this.albumMeta.write(output);
            output.writeFieldEnd();
        }
        if (this.joinTs != null) {
            output.writeFieldBegin("joinTs", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.joinTs);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixAlbumMember {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_270: TAppPhoenixUser = TAppPhoenixUser.read(input);
                        _args.member = value_270;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_271: TAppPhoenixAlbumMeta = TAppPhoenixAlbumMeta.read(input);
                        _args.albumMeta = value_271;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_272: Int64 = input.readI64();
                        _args.joinTs = value_272;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.member !== undefined && _args.albumMeta !== undefined && _args.joinTs !== undefined) {
            return new TAppPhoenixAlbumMember(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixAlbumMember from input");
        }
    }
}
export interface ITAppPhoenixAlbumInviteArgs {
    sender: TAppPhoenixUser;
    albumMeta: TAppPhoenixAlbumMeta;
    inviteTs: number | Int64;
}
export class TAppPhoenixAlbumInvite {
    public sender: TAppPhoenixUser;
    public albumMeta: TAppPhoenixAlbumMeta;
    public inviteTs: Int64;
    constructor(args: ITAppPhoenixAlbumInviteArgs) {
        if (args != null && args.sender != null) {
            this.sender = args.sender;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sender] is unset!");
        }
        if (args != null && args.albumMeta != null) {
            this.albumMeta = args.albumMeta;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumMeta] is unset!");
        }
        if (args != null && args.inviteTs != null) {
            if (typeof args.inviteTs === "number") {
                this.inviteTs = new Int64(args.inviteTs);
            }
            else {
                this.inviteTs = args.inviteTs;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[inviteTs] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixAlbumInvite");
        if (this.sender != null) {
            output.writeFieldBegin("sender", thrift.Thrift.Type.STRUCT, 1);
            this.sender.write(output);
            output.writeFieldEnd();
        }
        if (this.albumMeta != null) {
            output.writeFieldBegin("albumMeta", thrift.Thrift.Type.STRUCT, 2);
            this.albumMeta.write(output);
            output.writeFieldEnd();
        }
        if (this.inviteTs != null) {
            output.writeFieldBegin("inviteTs", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.inviteTs);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixAlbumInvite {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_273: TAppPhoenixUser = TAppPhoenixUser.read(input);
                        _args.sender = value_273;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_274: TAppPhoenixAlbumMeta = TAppPhoenixAlbumMeta.read(input);
                        _args.albumMeta = value_274;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_275: Int64 = input.readI64();
                        _args.inviteTs = value_275;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.sender !== undefined && _args.albumMeta !== undefined && _args.inviteTs !== undefined) {
            return new TAppPhoenixAlbumInvite(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixAlbumInvite from input");
        }
    }
}
export interface ITSendBulkAlbumInvitesRequestArgs {
    invite: TAppPhoenixAlbumInvite;
    inviteeUserIds: Array<string>;
    externalInvites?: Array<TAppPhoenixInviteContact>;
}
export class TSendBulkAlbumInvitesRequest {
    public invite: TAppPhoenixAlbumInvite;
    public inviteeUserIds: Array<string>;
    public externalInvites?: Array<TAppPhoenixInviteContact>;
    constructor(args: ITSendBulkAlbumInvitesRequestArgs) {
        if (args != null && args.invite != null) {
            this.invite = args.invite;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[invite] is unset!");
        }
        if (args != null && args.inviteeUserIds != null) {
            this.inviteeUserIds = args.inviteeUserIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[inviteeUserIds] is unset!");
        }
        if (args != null && args.externalInvites != null) {
            this.externalInvites = args.externalInvites;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSendBulkAlbumInvitesRequest");
        if (this.invite != null) {
            output.writeFieldBegin("invite", thrift.Thrift.Type.STRUCT, 1);
            this.invite.write(output);
            output.writeFieldEnd();
        }
        if (this.inviteeUserIds != null) {
            output.writeFieldBegin("inviteeUserIds", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.inviteeUserIds.length);
            this.inviteeUserIds.forEach((value_276: string): void => {
                output.writeString(value_276);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.externalInvites != null) {
            output.writeFieldBegin("externalInvites", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.externalInvites.length);
            this.externalInvites.forEach((value_277: TAppPhoenixInviteContact): void => {
                value_277.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSendBulkAlbumInvitesRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_278: TAppPhoenixAlbumInvite = TAppPhoenixAlbumInvite.read(input);
                        _args.invite = value_278;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_279: Array<string> = new Array<string>();
                        const metadata_31: thrift.TList = input.readListBegin();
                        const size_31: number = metadata_31.size;
                        for (let i_31: number = 0; i_31 < size_31; i_31++) {
                            const value_280: string = input.readString();
                            value_279.push(value_280);
                        }
                        input.readListEnd();
                        _args.inviteeUserIds = value_279;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_281: Array<TAppPhoenixInviteContact> = new Array<TAppPhoenixInviteContact>();
                        const metadata_32: thrift.TList = input.readListBegin();
                        const size_32: number = metadata_32.size;
                        for (let i_32: number = 0; i_32 < size_32; i_32++) {
                            const value_282: TAppPhoenixInviteContact = TAppPhoenixInviteContact.read(input);
                            value_281.push(value_282);
                        }
                        input.readListEnd();
                        _args.externalInvites = value_281;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.invite !== undefined && _args.inviteeUserIds !== undefined) {
            return new TSendBulkAlbumInvitesRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TSendBulkAlbumInvitesRequest from input");
        }
    }
}
export interface ITAppPhoenixInviteContactArgs {
    contactId: string;
    field: ContactLite.TAppContactField;
}
export class TAppPhoenixInviteContact {
    public contactId: string;
    public field: ContactLite.TAppContactField;
    constructor(args: ITAppPhoenixInviteContactArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contactId] is unset!");
        }
        if (args != null && args.field != null) {
            this.field = args.field;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[field] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixInviteContact");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.field != null) {
            output.writeFieldBegin("field", thrift.Thrift.Type.STRUCT, 2);
            this.field.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixInviteContact {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_283: string = input.readString();
                        _args.contactId = value_283;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_284: ContactLite.TAppContactField = ContactLite.TAppContactField.read(input);
                        _args.field = value_284;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contactId !== undefined && _args.field !== undefined) {
            return new TAppPhoenixInviteContact(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixInviteContact from input");
        }
    }
}
export interface ITSendBulkAlbumInvitesResponseArgs {
}
export class TSendBulkAlbumInvitesResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TSendBulkAlbumInvitesResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TSendBulkAlbumInvitesResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TSendBulkAlbumInvitesResponse();
    }
}
export interface ITAppPhoenixMutualMemberArgs {
    member: TAppPhoenixUser;
    sharedAlbumMetas: Array<TAppPhoenixAlbumMeta>;
}
export class TAppPhoenixMutualMember {
    public member: TAppPhoenixUser;
    public sharedAlbumMetas: Array<TAppPhoenixAlbumMeta>;
    constructor(args: ITAppPhoenixMutualMemberArgs) {
        if (args != null && args.member != null) {
            this.member = args.member;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[member] is unset!");
        }
        if (args != null && args.sharedAlbumMetas != null) {
            this.sharedAlbumMetas = args.sharedAlbumMetas;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[sharedAlbumMetas] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixMutualMember");
        if (this.member != null) {
            output.writeFieldBegin("member", thrift.Thrift.Type.STRUCT, 1);
            this.member.write(output);
            output.writeFieldEnd();
        }
        if (this.sharedAlbumMetas != null) {
            output.writeFieldBegin("sharedAlbumMetas", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.sharedAlbumMetas.length);
            this.sharedAlbumMetas.forEach((value_285: TAppPhoenixAlbumMeta): void => {
                value_285.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixMutualMember {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_286: TAppPhoenixUser = TAppPhoenixUser.read(input);
                        _args.member = value_286;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_287: Array<TAppPhoenixAlbumMeta> = new Array<TAppPhoenixAlbumMeta>();
                        const metadata_33: thrift.TList = input.readListBegin();
                        const size_33: number = metadata_33.size;
                        for (let i_33: number = 0; i_33 < size_33; i_33++) {
                            const value_288: TAppPhoenixAlbumMeta = TAppPhoenixAlbumMeta.read(input);
                            value_287.push(value_288);
                        }
                        input.readListEnd();
                        _args.sharedAlbumMetas = value_287;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.member !== undefined && _args.sharedAlbumMetas !== undefined) {
            return new TAppPhoenixMutualMember(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixMutualMember from input");
        }
    }
}
export interface ITFetchMutualMembersRequestArgs {
    pageToken: string;
}
export class TFetchMutualMembersRequest {
    public pageToken: string;
    constructor(args: ITFetchMutualMembersRequestArgs) {
        if (args != null && args.pageToken != null) {
            this.pageToken = args.pageToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[pageToken] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchMutualMembersRequest");
        if (this.pageToken != null) {
            output.writeFieldBegin("pageToken", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.pageToken);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchMutualMembersRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_289: string = input.readString();
                        _args.pageToken = value_289;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.pageToken !== undefined) {
            return new TFetchMutualMembersRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchMutualMembersRequest from input");
        }
    }
}
export interface ITFetchMutualMembersResponseArgs {
    mutualMembers: Array<TAppPhoenixMutualMember>;
    pageToken: string;
    hasMore: boolean;
}
export class TFetchMutualMembersResponse {
    public mutualMembers: Array<TAppPhoenixMutualMember>;
    public pageToken: string;
    public hasMore: boolean;
    constructor(args: ITFetchMutualMembersResponseArgs) {
        if (args != null && args.mutualMembers != null) {
            this.mutualMembers = args.mutualMembers;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[mutualMembers] is unset!");
        }
        if (args != null && args.pageToken != null) {
            this.pageToken = args.pageToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[pageToken] is unset!");
        }
        if (args != null && args.hasMore != null) {
            this.hasMore = args.hasMore;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[hasMore] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchMutualMembersResponse");
        if (this.mutualMembers != null) {
            output.writeFieldBegin("mutualMembers", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.mutualMembers.length);
            this.mutualMembers.forEach((value_290: TAppPhoenixMutualMember): void => {
                value_290.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.pageToken != null) {
            output.writeFieldBegin("pageToken", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.pageToken);
            output.writeFieldEnd();
        }
        if (this.hasMore != null) {
            output.writeFieldBegin("hasMore", thrift.Thrift.Type.BOOL, 3);
            output.writeBool(this.hasMore);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchMutualMembersResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_291: Array<TAppPhoenixMutualMember> = new Array<TAppPhoenixMutualMember>();
                        const metadata_34: thrift.TList = input.readListBegin();
                        const size_34: number = metadata_34.size;
                        for (let i_34: number = 0; i_34 < size_34; i_34++) {
                            const value_292: TAppPhoenixMutualMember = TAppPhoenixMutualMember.read(input);
                            value_291.push(value_292);
                        }
                        input.readListEnd();
                        _args.mutualMembers = value_291;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_293: string = input.readString();
                        _args.pageToken = value_293;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_294: boolean = input.readBool();
                        _args.hasMore = value_294;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.mutualMembers !== undefined && _args.pageToken !== undefined && _args.hasMore !== undefined) {
            return new TFetchMutualMembersResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchMutualMembersResponse from input");
        }
    }
}
export interface ITAppOnDeviceTaskArgs {
    taskId: string;
    photoId: string;
    taskTypes: Array<TAppOnDeviceTaskType>;
}
export class TAppOnDeviceTask {
    public taskId: string;
    public photoId: string;
    public taskTypes: Array<TAppOnDeviceTaskType>;
    constructor(args: ITAppOnDeviceTaskArgs) {
        if (args != null && args.taskId != null) {
            this.taskId = args.taskId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[taskId] is unset!");
        }
        if (args != null && args.photoId != null) {
            this.photoId = args.photoId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoId] is unset!");
        }
        if (args != null && args.taskTypes != null) {
            this.taskTypes = args.taskTypes;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[taskTypes] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppOnDeviceTask");
        if (this.taskId != null) {
            output.writeFieldBegin("taskId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.taskId);
            output.writeFieldEnd();
        }
        if (this.photoId != null) {
            output.writeFieldBegin("photoId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.photoId);
            output.writeFieldEnd();
        }
        if (this.taskTypes != null) {
            output.writeFieldBegin("taskTypes", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.I32, this.taskTypes.length);
            this.taskTypes.forEach((value_295: TAppOnDeviceTaskType): void => {
                output.writeI32(value_295);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppOnDeviceTask {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_296: string = input.readString();
                        _args.taskId = value_296;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_297: string = input.readString();
                        _args.photoId = value_297;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_298: Array<TAppOnDeviceTaskType> = new Array<TAppOnDeviceTaskType>();
                        const metadata_35: thrift.TList = input.readListBegin();
                        const size_35: number = metadata_35.size;
                        for (let i_35: number = 0; i_35 < size_35; i_35++) {
                            const value_299: TAppOnDeviceTaskType = input.readI32();
                            value_298.push(value_299);
                        }
                        input.readListEnd();
                        _args.taskTypes = value_298;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.taskId !== undefined && _args.photoId !== undefined && _args.taskTypes !== undefined) {
            return new TAppOnDeviceTask(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppOnDeviceTask from input");
        }
    }
}
export interface ITAppOnDeviceTaskResultArgs {
    task: TAppOnDeviceTask;
    featurePrintV1?: Array<number>;
    featurePrintV2?: Array<number>;
    phash?: string;
    faceCount?: number;
    ocrCharCount?: number;
    laplacianVariance?: number;
}
export class TAppOnDeviceTaskResult {
    public task: TAppOnDeviceTask;
    public featurePrintV1?: Array<number>;
    public featurePrintV2?: Array<number>;
    public phash?: string;
    public faceCount?: number;
    public ocrCharCount?: number;
    public laplacianVariance?: number;
    constructor(args: ITAppOnDeviceTaskResultArgs) {
        if (args != null && args.task != null) {
            this.task = args.task;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[task] is unset!");
        }
        if (args != null && args.featurePrintV1 != null) {
            this.featurePrintV1 = args.featurePrintV1;
        }
        if (args != null && args.featurePrintV2 != null) {
            this.featurePrintV2 = args.featurePrintV2;
        }
        if (args != null && args.phash != null) {
            this.phash = args.phash;
        }
        if (args != null && args.faceCount != null) {
            this.faceCount = args.faceCount;
        }
        if (args != null && args.ocrCharCount != null) {
            this.ocrCharCount = args.ocrCharCount;
        }
        if (args != null && args.laplacianVariance != null) {
            this.laplacianVariance = args.laplacianVariance;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppOnDeviceTaskResult");
        if (this.task != null) {
            output.writeFieldBegin("task", thrift.Thrift.Type.STRUCT, 1);
            this.task.write(output);
            output.writeFieldEnd();
        }
        if (this.featurePrintV1 != null) {
            output.writeFieldBegin("featurePrintV1", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.DOUBLE, this.featurePrintV1.length);
            this.featurePrintV1.forEach((value_300: number): void => {
                output.writeDouble(value_300);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.featurePrintV2 != null) {
            output.writeFieldBegin("featurePrintV2", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.DOUBLE, this.featurePrintV2.length);
            this.featurePrintV2.forEach((value_301: number): void => {
                output.writeDouble(value_301);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.phash != null) {
            output.writeFieldBegin("phash", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.phash);
            output.writeFieldEnd();
        }
        if (this.faceCount != null) {
            output.writeFieldBegin("faceCount", thrift.Thrift.Type.I32, 5);
            output.writeI32(this.faceCount);
            output.writeFieldEnd();
        }
        if (this.ocrCharCount != null) {
            output.writeFieldBegin("ocrCharCount", thrift.Thrift.Type.I32, 6);
            output.writeI32(this.ocrCharCount);
            output.writeFieldEnd();
        }
        if (this.laplacianVariance != null) {
            output.writeFieldBegin("laplacianVariance", thrift.Thrift.Type.DOUBLE, 7);
            output.writeDouble(this.laplacianVariance);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppOnDeviceTaskResult {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_302: TAppOnDeviceTask = TAppOnDeviceTask.read(input);
                        _args.task = value_302;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_303: Array<number> = new Array<number>();
                        const metadata_36: thrift.TList = input.readListBegin();
                        const size_36: number = metadata_36.size;
                        for (let i_36: number = 0; i_36 < size_36; i_36++) {
                            const value_304: number = input.readDouble();
                            value_303.push(value_304);
                        }
                        input.readListEnd();
                        _args.featurePrintV1 = value_303;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_305: Array<number> = new Array<number>();
                        const metadata_37: thrift.TList = input.readListBegin();
                        const size_37: number = metadata_37.size;
                        for (let i_37: number = 0; i_37 < size_37; i_37++) {
                            const value_306: number = input.readDouble();
                            value_305.push(value_306);
                        }
                        input.readListEnd();
                        _args.featurePrintV2 = value_305;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_307: string = input.readString();
                        _args.phash = value_307;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_308: number = input.readI32();
                        _args.faceCount = value_308;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_309: number = input.readI32();
                        _args.ocrCharCount = value_309;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.DOUBLE) {
                        const value_310: number = input.readDouble();
                        _args.laplacianVariance = value_310;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.task !== undefined) {
            return new TAppOnDeviceTaskResult(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppOnDeviceTaskResult from input");
        }
    }
}
export interface ITFetchOnDeviceTasksRequestArgs {
}
export class TFetchOnDeviceTasksRequest {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchOnDeviceTasksRequest");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchOnDeviceTasksRequest {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchOnDeviceTasksRequest();
    }
}
export interface ITFetchOnDeviceTasksResponseArgs {
    tasks: Array<TAppOnDeviceTask>;
}
export class TFetchOnDeviceTasksResponse {
    public tasks: Array<TAppOnDeviceTask>;
    constructor(args: ITFetchOnDeviceTasksResponseArgs) {
        if (args != null && args.tasks != null) {
            this.tasks = args.tasks;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[tasks] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchOnDeviceTasksResponse");
        if (this.tasks != null) {
            output.writeFieldBegin("tasks", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.tasks.length);
            this.tasks.forEach((value_311: TAppOnDeviceTask): void => {
                value_311.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchOnDeviceTasksResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_312: Array<TAppOnDeviceTask> = new Array<TAppOnDeviceTask>();
                        const metadata_38: thrift.TList = input.readListBegin();
                        const size_38: number = metadata_38.size;
                        for (let i_38: number = 0; i_38 < size_38; i_38++) {
                            const value_313: TAppOnDeviceTask = TAppOnDeviceTask.read(input);
                            value_312.push(value_313);
                        }
                        input.readListEnd();
                        _args.tasks = value_312;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.tasks !== undefined) {
            return new TFetchOnDeviceTasksResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchOnDeviceTasksResponse from input");
        }
    }
}
export interface ITCompleteOnDeviceTaskRequestArgs {
    results: Array<TAppOnDeviceTaskResult>;
}
export class TCompleteOnDeviceTaskRequest {
    public results: Array<TAppOnDeviceTaskResult>;
    constructor(args: ITCompleteOnDeviceTaskRequestArgs) {
        if (args != null && args.results != null) {
            this.results = args.results;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[results] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TCompleteOnDeviceTaskRequest");
        if (this.results != null) {
            output.writeFieldBegin("results", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.results.length);
            this.results.forEach((value_314: TAppOnDeviceTaskResult): void => {
                value_314.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TCompleteOnDeviceTaskRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_315: Array<TAppOnDeviceTaskResult> = new Array<TAppOnDeviceTaskResult>();
                        const metadata_39: thrift.TList = input.readListBegin();
                        const size_39: number = metadata_39.size;
                        for (let i_39: number = 0; i_39 < size_39; i_39++) {
                            const value_316: TAppOnDeviceTaskResult = TAppOnDeviceTaskResult.read(input);
                            value_315.push(value_316);
                        }
                        input.readListEnd();
                        _args.results = value_315;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.results !== undefined) {
            return new TCompleteOnDeviceTaskRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TCompleteOnDeviceTaskRequest from input");
        }
    }
}
export interface ITCompleteOnDeviceTaskResponseArgs {
}
export class TCompleteOnDeviceTaskResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TCompleteOnDeviceTaskResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TCompleteOnDeviceTaskResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TCompleteOnDeviceTaskResponse();
    }
}
export interface ITDeletePhotoMetaRequestArgs {
    photoIds: Array<string>;
}
export class TDeletePhotoMetaRequest {
    public photoIds: Array<string>;
    constructor(args: ITDeletePhotoMetaRequestArgs) {
        if (args != null && args.photoIds != null) {
            this.photoIds = args.photoIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoIds] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeletePhotoMetaRequest");
        if (this.photoIds != null) {
            output.writeFieldBegin("photoIds", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.photoIds.length);
            this.photoIds.forEach((value_317: string): void => {
                output.writeString(value_317);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeletePhotoMetaRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_318: Array<string> = new Array<string>();
                        const metadata_40: thrift.TList = input.readListBegin();
                        const size_40: number = metadata_40.size;
                        for (let i_40: number = 0; i_40 < size_40; i_40++) {
                            const value_319: string = input.readString();
                            value_318.push(value_319);
                        }
                        input.readListEnd();
                        _args.photoIds = value_318;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.photoIds !== undefined) {
            return new TDeletePhotoMetaRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDeletePhotoMetaRequest from input");
        }
    }
}
export interface ITDeletePhotoMetaResponseArgs {
}
export class TDeletePhotoMetaResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeletePhotoMetaResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeletePhotoMetaResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TDeletePhotoMetaResponse();
    }
}
export interface ITFetchContactSuggestionsRequestArgs {
    pageToken?: string;
    numRows?: number;
}
export class TFetchContactSuggestionsRequest {
    public pageToken?: string;
    public numRows?: number = 1000;
    constructor(args?: ITFetchContactSuggestionsRequestArgs) {
        if (args != null && args.pageToken != null) {
            this.pageToken = args.pageToken;
        }
        if (args != null && args.numRows != null) {
            this.numRows = args.numRows;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchContactSuggestionsRequest");
        if (this.pageToken != null) {
            output.writeFieldBegin("pageToken", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.pageToken);
            output.writeFieldEnd();
        }
        if (this.numRows != null) {
            output.writeFieldBegin("numRows", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.numRows);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchContactSuggestionsRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_320: string = input.readString();
                        _args.pageToken = value_320;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_321: number = input.readI32();
                        _args.numRows = value_321;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchContactSuggestionsRequest(_args);
    }
}
export interface ITFetchContactSuggestionsResponseArgs {
    contacts: Array<ContactLite.TAppContactLite>;
    nextPageToken: string;
    hasMore: boolean;
}
export class TFetchContactSuggestionsResponse {
    public contacts: Array<ContactLite.TAppContactLite>;
    public nextPageToken: string;
    public hasMore: boolean;
    constructor(args: ITFetchContactSuggestionsResponseArgs) {
        if (args != null && args.contacts != null) {
            this.contacts = args.contacts;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[contacts] is unset!");
        }
        if (args != null && args.nextPageToken != null) {
            this.nextPageToken = args.nextPageToken;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[nextPageToken] is unset!");
        }
        if (args != null && args.hasMore != null) {
            this.hasMore = args.hasMore;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[hasMore] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchContactSuggestionsResponse");
        if (this.contacts != null) {
            output.writeFieldBegin("contacts", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.contacts.length);
            this.contacts.forEach((value_322: ContactLite.TAppContactLite): void => {
                value_322.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.nextPageToken != null) {
            output.writeFieldBegin("nextPageToken", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.nextPageToken);
            output.writeFieldEnd();
        }
        if (this.hasMore != null) {
            output.writeFieldBegin("hasMore", thrift.Thrift.Type.BOOL, 3);
            output.writeBool(this.hasMore);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchContactSuggestionsResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_323: Array<ContactLite.TAppContactLite> = new Array<ContactLite.TAppContactLite>();
                        const metadata_41: thrift.TList = input.readListBegin();
                        const size_41: number = metadata_41.size;
                        for (let i_41: number = 0; i_41 < size_41; i_41++) {
                            const value_324: ContactLite.TAppContactLite = ContactLite.TAppContactLite.read(input);
                            value_323.push(value_324);
                        }
                        input.readListEnd();
                        _args.contacts = value_323;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_325: string = input.readString();
                        _args.nextPageToken = value_325;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_326: boolean = input.readBool();
                        _args.hasMore = value_326;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.contacts !== undefined && _args.nextPageToken !== undefined && _args.hasMore !== undefined) {
            return new TFetchContactSuggestionsResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchContactSuggestionsResponse from input");
        }
    }
}
export interface ITArchiveAlbumShareSuggestionRequestArgs {
    albumId: string;
    placement: TAlbumShareSuggestionPlacement;
}
export class TArchiveAlbumShareSuggestionRequest {
    public albumId: string;
    public placement: TAlbumShareSuggestionPlacement;
    constructor(args: ITArchiveAlbumShareSuggestionRequestArgs) {
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.placement != null) {
            this.placement = args.placement;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[placement] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TArchiveAlbumShareSuggestionRequest");
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.placement != null) {
            output.writeFieldBegin("placement", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.placement);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TArchiveAlbumShareSuggestionRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_327: string = input.readString();
                        _args.albumId = value_327;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_328: TAlbumShareSuggestionPlacement = input.readI32();
                        _args.placement = value_328;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined && _args.placement !== undefined) {
            return new TArchiveAlbumShareSuggestionRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TArchiveAlbumShareSuggestionRequest from input");
        }
    }
}
export interface ITArchiveAlbumShareSuggestionResponseArgs {
}
export class TArchiveAlbumShareSuggestionResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TArchiveAlbumShareSuggestionResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TArchiveAlbumShareSuggestionResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TArchiveAlbumShareSuggestionResponse();
    }
}
export interface ITChangeAlbumNotificationSettingRequestArgs {
    albumId: string;
    notificationEnabled: boolean;
}
export class TChangeAlbumNotificationSettingRequest {
    public albumId: string;
    public notificationEnabled: boolean;
    constructor(args: ITChangeAlbumNotificationSettingRequestArgs) {
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.notificationEnabled != null) {
            this.notificationEnabled = args.notificationEnabled;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[notificationEnabled] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TChangeAlbumNotificationSettingRequest");
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.notificationEnabled != null) {
            output.writeFieldBegin("notificationEnabled", thrift.Thrift.Type.BOOL, 2);
            output.writeBool(this.notificationEnabled);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TChangeAlbumNotificationSettingRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_329: string = input.readString();
                        _args.albumId = value_329;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_330: boolean = input.readBool();
                        _args.notificationEnabled = value_330;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined && _args.notificationEnabled !== undefined) {
            return new TChangeAlbumNotificationSettingRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TChangeAlbumNotificationSettingRequest from input");
        }
    }
}
export interface ITChangeAlbumNotificationSettingResponseArgs {
}
export class TChangeAlbumNotificationSettingResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TChangeAlbumNotificationSettingResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TChangeAlbumNotificationSettingResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TChangeAlbumNotificationSettingResponse();
    }
}
export interface ITAppPhoenixFaceTagArgs {
    contactId?: string;
    displayName?: string;
    taggedUserId?: string;
    taggedPhone?: string;
    taggedEmail?: string;
    notSure?: boolean;
}
export class TAppPhoenixFaceTag {
    public contactId?: string;
    public displayName?: string;
    public taggedUserId?: string;
    public taggedPhone?: string;
    public taggedEmail?: string;
    public notSure?: boolean;
    constructor(args?: ITAppPhoenixFaceTagArgs) {
        if (args != null && args.contactId != null) {
            this.contactId = args.contactId;
        }
        if (args != null && args.displayName != null) {
            this.displayName = args.displayName;
        }
        if (args != null && args.taggedUserId != null) {
            this.taggedUserId = args.taggedUserId;
        }
        if (args != null && args.taggedPhone != null) {
            this.taggedPhone = args.taggedPhone;
        }
        if (args != null && args.taggedEmail != null) {
            this.taggedEmail = args.taggedEmail;
        }
        if (args != null && args.notSure != null) {
            this.notSure = args.notSure;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixFaceTag");
        if (this.contactId != null) {
            output.writeFieldBegin("contactId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.contactId);
            output.writeFieldEnd();
        }
        if (this.displayName != null) {
            output.writeFieldBegin("displayName", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.displayName);
            output.writeFieldEnd();
        }
        if (this.taggedUserId != null) {
            output.writeFieldBegin("taggedUserId", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.taggedUserId);
            output.writeFieldEnd();
        }
        if (this.taggedPhone != null) {
            output.writeFieldBegin("taggedPhone", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.taggedPhone);
            output.writeFieldEnd();
        }
        if (this.taggedEmail != null) {
            output.writeFieldBegin("taggedEmail", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.taggedEmail);
            output.writeFieldEnd();
        }
        if (this.notSure != null) {
            output.writeFieldBegin("notSure", thrift.Thrift.Type.BOOL, 6);
            output.writeBool(this.notSure);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixFaceTag {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_331: string = input.readString();
                        _args.contactId = value_331;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_332: string = input.readString();
                        _args.displayName = value_332;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_333: string = input.readString();
                        _args.taggedUserId = value_333;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_334: string = input.readString();
                        _args.taggedPhone = value_334;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_335: string = input.readString();
                        _args.taggedEmail = value_335;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_336: boolean = input.readBool();
                        _args.notSure = value_336;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAppPhoenixFaceTag(_args);
    }
}
export interface ITAppPhoenixFaceSelectionsArgs {
    selectedFaceIds: Array<string>;
    deselectedFaceIds: Array<string>;
}
export class TAppPhoenixFaceSelections {
    public selectedFaceIds: Array<string>;
    public deselectedFaceIds: Array<string>;
    constructor(args: ITAppPhoenixFaceSelectionsArgs) {
        if (args != null && args.selectedFaceIds != null) {
            this.selectedFaceIds = args.selectedFaceIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[selectedFaceIds] is unset!");
        }
        if (args != null && args.deselectedFaceIds != null) {
            this.deselectedFaceIds = args.deselectedFaceIds;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[deselectedFaceIds] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixFaceSelections");
        if (this.selectedFaceIds != null) {
            output.writeFieldBegin("selectedFaceIds", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.selectedFaceIds.length);
            this.selectedFaceIds.forEach((value_337: string): void => {
                output.writeString(value_337);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.deselectedFaceIds != null) {
            output.writeFieldBegin("deselectedFaceIds", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRING, this.deselectedFaceIds.length);
            this.deselectedFaceIds.forEach((value_338: string): void => {
                output.writeString(value_338);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixFaceSelections {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_339: Array<string> = new Array<string>();
                        const metadata_42: thrift.TList = input.readListBegin();
                        const size_42: number = metadata_42.size;
                        for (let i_42: number = 0; i_42 < size_42; i_42++) {
                            const value_340: string = input.readString();
                            value_339.push(value_340);
                        }
                        input.readListEnd();
                        _args.selectedFaceIds = value_339;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_341: Array<string> = new Array<string>();
                        const metadata_43: thrift.TList = input.readListBegin();
                        const size_43: number = metadata_43.size;
                        for (let i_43: number = 0; i_43 < size_43; i_43++) {
                            const value_342: string = input.readString();
                            value_341.push(value_342);
                        }
                        input.readListEnd();
                        _args.deselectedFaceIds = value_341;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.selectedFaceIds !== undefined && _args.deselectedFaceIds !== undefined) {
            return new TAppPhoenixFaceSelections(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixFaceSelections from input");
        }
    }
}
export interface ITTagAlbumFaceRequestArgs {
    albumId: string;
    localFaceId: string;
    faceTag: TAppPhoenixFaceTag;
    faceSelections?: TAppPhoenixFaceSelections;
}
export class TTagAlbumFaceRequest {
    public albumId: string;
    public localFaceId: string;
    public faceTag: TAppPhoenixFaceTag;
    public faceSelections?: TAppPhoenixFaceSelections;
    constructor(args: ITTagAlbumFaceRequestArgs) {
        if (args != null && args.albumId != null) {
            this.albumId = args.albumId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumId] is unset!");
        }
        if (args != null && args.localFaceId != null) {
            this.localFaceId = args.localFaceId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[localFaceId] is unset!");
        }
        if (args != null && args.faceTag != null) {
            this.faceTag = args.faceTag;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[faceTag] is unset!");
        }
        if (args != null && args.faceSelections != null) {
            this.faceSelections = args.faceSelections;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TTagAlbumFaceRequest");
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        if (this.localFaceId != null) {
            output.writeFieldBegin("localFaceId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.localFaceId);
            output.writeFieldEnd();
        }
        if (this.faceTag != null) {
            output.writeFieldBegin("faceTag", thrift.Thrift.Type.STRUCT, 3);
            this.faceTag.write(output);
            output.writeFieldEnd();
        }
        if (this.faceSelections != null) {
            output.writeFieldBegin("faceSelections", thrift.Thrift.Type.STRUCT, 4);
            this.faceSelections.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TTagAlbumFaceRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_343: string = input.readString();
                        _args.albumId = value_343;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_344: string = input.readString();
                        _args.localFaceId = value_344;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_345: TAppPhoenixFaceTag = TAppPhoenixFaceTag.read(input);
                        _args.faceTag = value_345;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_346: TAppPhoenixFaceSelections = TAppPhoenixFaceSelections.read(input);
                        _args.faceSelections = value_346;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumId !== undefined && _args.localFaceId !== undefined && _args.faceTag !== undefined) {
            return new TTagAlbumFaceRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TTagAlbumFaceRequest from input");
        }
    }
}
export interface ITTagAlbumFaceResponseArgs {
    updatedFace?: TAppPhoenixAlbumFace;
}
export class TTagAlbumFaceResponse {
    public updatedFace?: TAppPhoenixAlbumFace;
    constructor(args?: ITTagAlbumFaceResponseArgs) {
        if (args != null && args.updatedFace != null) {
            this.updatedFace = args.updatedFace;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TTagAlbumFaceResponse");
        if (this.updatedFace != null) {
            output.writeFieldBegin("updatedFace", thrift.Thrift.Type.STRUCT, 1);
            this.updatedFace.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TTagAlbumFaceResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_347: TAppPhoenixAlbumFace = TAppPhoenixAlbumFace.read(input);
                        _args.updatedFace = value_347;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TTagAlbumFaceResponse(_args);
    }
}
export interface ITAppPhoenixPhotoMetaLiteArgs {
    ownerUserId: string;
    photoId: string;
    photoTs: number | Int64;
    clusterId: number | Int64;
    isKeyPhoto: boolean;
    thumbnailUrl?: string;
}
export class TAppPhoenixPhotoMetaLite {
    public ownerUserId: string;
    public photoId: string;
    public photoTs: Int64;
    public clusterId: Int64;
    public isKeyPhoto: boolean;
    public thumbnailUrl?: string;
    constructor(args: ITAppPhoenixPhotoMetaLiteArgs) {
        if (args != null && args.ownerUserId != null) {
            this.ownerUserId = args.ownerUserId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[ownerUserId] is unset!");
        }
        if (args != null && args.photoId != null) {
            this.photoId = args.photoId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoId] is unset!");
        }
        if (args != null && args.photoTs != null) {
            if (typeof args.photoTs === "number") {
                this.photoTs = new Int64(args.photoTs);
            }
            else {
                this.photoTs = args.photoTs;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[photoTs] is unset!");
        }
        if (args != null && args.clusterId != null) {
            if (typeof args.clusterId === "number") {
                this.clusterId = new Int64(args.clusterId);
            }
            else {
                this.clusterId = args.clusterId;
            }
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[clusterId] is unset!");
        }
        if (args != null && args.isKeyPhoto != null) {
            this.isKeyPhoto = args.isKeyPhoto;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[isKeyPhoto] is unset!");
        }
        if (args != null && args.thumbnailUrl != null) {
            this.thumbnailUrl = args.thumbnailUrl;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixPhotoMetaLite");
        if (this.ownerUserId != null) {
            output.writeFieldBegin("ownerUserId", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.ownerUserId);
            output.writeFieldEnd();
        }
        if (this.photoId != null) {
            output.writeFieldBegin("photoId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.photoId);
            output.writeFieldEnd();
        }
        if (this.photoTs != null) {
            output.writeFieldBegin("photoTs", thrift.Thrift.Type.I64, 2);
            output.writeI64(this.photoTs);
            output.writeFieldEnd();
        }
        if (this.clusterId != null) {
            output.writeFieldBegin("clusterId", thrift.Thrift.Type.I64, 3);
            output.writeI64(this.clusterId);
            output.writeFieldEnd();
        }
        if (this.isKeyPhoto != null) {
            output.writeFieldBegin("isKeyPhoto", thrift.Thrift.Type.BOOL, 4);
            output.writeBool(this.isKeyPhoto);
            output.writeFieldEnd();
        }
        if (this.thumbnailUrl != null) {
            output.writeFieldBegin("thumbnailUrl", thrift.Thrift.Type.STRING, 5);
            output.writeString(this.thumbnailUrl);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixPhotoMetaLite {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_348: string = input.readString();
                        _args.ownerUserId = value_348;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_349: string = input.readString();
                        _args.photoId = value_349;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_350: Int64 = input.readI64();
                        _args.photoTs = value_350;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I64) {
                        const value_351: Int64 = input.readI64();
                        _args.clusterId = value_351;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_352: boolean = input.readBool();
                        _args.isKeyPhoto = value_352;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_353: string = input.readString();
                        _args.thumbnailUrl = value_353;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.ownerUserId !== undefined && _args.photoId !== undefined && _args.photoTs !== undefined && _args.clusterId !== undefined && _args.isKeyPhoto !== undefined) {
            return new TAppPhoenixPhotoMetaLite(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixPhotoMetaLite from input");
        }
    }
}
export interface ITAppPhoenixAlbumLiteArgs {
    albumMeta: TAppPhoenixAlbumMeta;
    latestPhotos: Array<TAppPhoenixPhotoMetaLite>;
    totalPhotoCount?: number;
}
export class TAppPhoenixAlbumLite {
    public albumMeta: TAppPhoenixAlbumMeta;
    public latestPhotos: Array<TAppPhoenixPhotoMetaLite>;
    public totalPhotoCount?: number;
    constructor(args: ITAppPhoenixAlbumLiteArgs) {
        if (args != null && args.albumMeta != null) {
            this.albumMeta = args.albumMeta;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumMeta] is unset!");
        }
        if (args != null && args.latestPhotos != null) {
            this.latestPhotos = args.latestPhotos;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[latestPhotos] is unset!");
        }
        if (args != null && args.totalPhotoCount != null) {
            this.totalPhotoCount = args.totalPhotoCount;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixAlbumLite");
        if (this.albumMeta != null) {
            output.writeFieldBegin("albumMeta", thrift.Thrift.Type.STRUCT, 1);
            this.albumMeta.write(output);
            output.writeFieldEnd();
        }
        if (this.latestPhotos != null) {
            output.writeFieldBegin("latestPhotos", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.latestPhotos.length);
            this.latestPhotos.forEach((value_354: TAppPhoenixPhotoMetaLite): void => {
                value_354.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.totalPhotoCount != null) {
            output.writeFieldBegin("totalPhotoCount", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.totalPhotoCount);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixAlbumLite {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_355: TAppPhoenixAlbumMeta = TAppPhoenixAlbumMeta.read(input);
                        _args.albumMeta = value_355;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_356: Array<TAppPhoenixPhotoMetaLite> = new Array<TAppPhoenixPhotoMetaLite>();
                        const metadata_44: thrift.TList = input.readListBegin();
                        const size_44: number = metadata_44.size;
                        for (let i_44: number = 0; i_44 < size_44; i_44++) {
                            const value_357: TAppPhoenixPhotoMetaLite = TAppPhoenixPhotoMetaLite.read(input);
                            value_356.push(value_357);
                        }
                        input.readListEnd();
                        _args.latestPhotos = value_356;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_358: number = input.readI32();
                        _args.totalPhotoCount = value_358;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albumMeta !== undefined && _args.latestPhotos !== undefined) {
            return new TAppPhoenixAlbumLite(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppPhoenixAlbumLite from input");
        }
    }
}
export interface ITFetchAlbumListRequestArgs {
    albumListModId?: string;
    limit?: number;
}
export class TFetchAlbumListRequest {
    public albumListModId?: string;
    public limit?: number;
    constructor(args?: ITFetchAlbumListRequestArgs) {
        if (args != null && args.albumListModId != null) {
            this.albumListModId = args.albumListModId;
        }
        if (args != null && args.limit != null) {
            this.limit = args.limit;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchAlbumListRequest");
        if (this.albumListModId != null) {
            output.writeFieldBegin("albumListModId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumListModId);
            output.writeFieldEnd();
        }
        if (this.limit != null) {
            output.writeFieldBegin("limit", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.limit);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchAlbumListRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_359: string = input.readString();
                        _args.albumListModId = value_359;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_360: number = input.readI32();
                        _args.limit = value_360;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchAlbumListRequest(_args);
    }
}
export interface ITFetchAlbumListResponseArgs {
    albums: Array<TAppPhoenixAlbumLite>;
    hasMore: boolean;
    albumListModId: string;
}
export class TFetchAlbumListResponse {
    public albums: Array<TAppPhoenixAlbumLite>;
    public hasMore: boolean;
    public albumListModId: string;
    constructor(args: ITFetchAlbumListResponseArgs) {
        if (args != null && args.albums != null) {
            this.albums = args.albums;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albums] is unset!");
        }
        if (args != null && args.hasMore != null) {
            this.hasMore = args.hasMore;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[hasMore] is unset!");
        }
        if (args != null && args.albumListModId != null) {
            this.albumListModId = args.albumListModId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[albumListModId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchAlbumListResponse");
        if (this.albums != null) {
            output.writeFieldBegin("albums", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.albums.length);
            this.albums.forEach((value_361: TAppPhoenixAlbumLite): void => {
                value_361.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.hasMore != null) {
            output.writeFieldBegin("hasMore", thrift.Thrift.Type.BOOL, 2);
            output.writeBool(this.hasMore);
            output.writeFieldEnd();
        }
        if (this.albumListModId != null) {
            output.writeFieldBegin("albumListModId", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.albumListModId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchAlbumListResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_362: Array<TAppPhoenixAlbumLite> = new Array<TAppPhoenixAlbumLite>();
                        const metadata_45: thrift.TList = input.readListBegin();
                        const size_45: number = metadata_45.size;
                        for (let i_45: number = 0; i_45 < size_45; i_45++) {
                            const value_363: TAppPhoenixAlbumLite = TAppPhoenixAlbumLite.read(input);
                            value_362.push(value_363);
                        }
                        input.readListEnd();
                        _args.albums = value_362;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_364: boolean = input.readBool();
                        _args.hasMore = value_364;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_365: string = input.readString();
                        _args.albumListModId = value_365;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.albums !== undefined && _args.hasMore !== undefined && _args.albumListModId !== undefined) {
            return new TFetchAlbumListResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchAlbumListResponse from input");
        }
    }
}
export interface ITAppPhoenixFetchAlbumMetaKeyArgs {
    albumCode?: string;
    albumId?: string;
}
export class TAppPhoenixFetchAlbumMetaKey {
    public albumCode?: string;
    public albumId?: string;
    constructor(args?: ITAppPhoenixFetchAlbumMetaKeyArgs) {
        let _fieldsSet: number = 0;
        if (args != null) {
            if (args.albumCode != null) {
                _fieldsSet++;
                this.albumCode = args.albumCode;
            }
            if (args.albumId != null) {
                _fieldsSet++;
                this.albumId = args.albumId;
            }
            if (_fieldsSet > 1) {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with more than one set value!");
            }
            else if (_fieldsSet < 1) {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with no set value!");
            }
        }
    }
    public static fromAlbumCode(albumCode: string): TAppPhoenixFetchAlbumMetaKey {
        return new TAppPhoenixFetchAlbumMetaKey({ albumCode });
    }
    public static fromAlbumId(albumId: string): TAppPhoenixFetchAlbumMetaKey {
        return new TAppPhoenixFetchAlbumMetaKey({ albumId });
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixFetchAlbumMetaKey");
        if (this.albumCode != null) {
            output.writeFieldBegin("albumCode", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.albumCode);
            output.writeFieldEnd();
        }
        if (this.albumId != null) {
            output.writeFieldBegin("albumId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.albumId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixFetchAlbumMetaKey {
        let _fieldsSet: number = 0;
        let _returnValue: TAppPhoenixFetchAlbumMetaKey | null = null;
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        _fieldsSet++;
                        const value_366: string = input.readString();
                        _returnValue = TAppPhoenixFetchAlbumMetaKey.fromAlbumCode(value_366);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        _fieldsSet++;
                        const value_367: string = input.readString();
                        _returnValue = TAppPhoenixFetchAlbumMetaKey.fromAlbumId(value_367);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_fieldsSet > 1) {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with more than one set value!");
        }
        else if (_fieldsSet < 1) {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with no set value!");
        }
        if (_returnValue !== null) {
            return _returnValue;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read data for TUnion");
        }
    }
}
export interface ITAppPhoenixHomepageItemArgs {
    cluster?: TAppPhoenixHomepageCluster;
    album?: TAppPhoenixHomepageAlbum;
    suggestedAlbum?: TAppPhoenixHomepageAlbumSuggestion;
    suggestedPhotos?: TAppPhoenixHomepagePhotosSuggestion;
    albumShareSuggestion?: TAppPhoenixHomepageAlbumShareSuggestion;
    albumFaceTagSuggestion?: TAppPhoenixHomepageAlbumFaceTagSuggestion;
}
export class TAppPhoenixHomepageItem {
    public cluster?: TAppPhoenixHomepageCluster;
    public album?: TAppPhoenixHomepageAlbum;
    public suggestedAlbum?: TAppPhoenixHomepageAlbumSuggestion;
    public suggestedPhotos?: TAppPhoenixHomepagePhotosSuggestion;
    public albumShareSuggestion?: TAppPhoenixHomepageAlbumShareSuggestion;
    public albumFaceTagSuggestion?: TAppPhoenixHomepageAlbumFaceTagSuggestion;
    constructor(args?: ITAppPhoenixHomepageItemArgs) {
        let _fieldsSet: number = 0;
        if (args != null) {
            if (args.cluster != null) {
                _fieldsSet++;
                this.cluster = args.cluster;
            }
            if (args.album != null) {
                _fieldsSet++;
                this.album = args.album;
            }
            if (args.suggestedAlbum != null) {
                _fieldsSet++;
                this.suggestedAlbum = args.suggestedAlbum;
            }
            if (args.suggestedPhotos != null) {
                _fieldsSet++;
                this.suggestedPhotos = args.suggestedPhotos;
            }
            if (args.albumShareSuggestion != null) {
                _fieldsSet++;
                this.albumShareSuggestion = args.albumShareSuggestion;
            }
            if (args.albumFaceTagSuggestion != null) {
                _fieldsSet++;
                this.albumFaceTagSuggestion = args.albumFaceTagSuggestion;
            }
            if (_fieldsSet > 1) {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with more than one set value!");
            }
            else if (_fieldsSet < 1) {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with no set value!");
            }
        }
    }
    public static fromCluster(cluster: TAppPhoenixHomepageCluster): TAppPhoenixHomepageItem {
        return new TAppPhoenixHomepageItem({ cluster });
    }
    public static fromAlbum(album: TAppPhoenixHomepageAlbum): TAppPhoenixHomepageItem {
        return new TAppPhoenixHomepageItem({ album });
    }
    public static fromSuggestedAlbum(suggestedAlbum: TAppPhoenixHomepageAlbumSuggestion): TAppPhoenixHomepageItem {
        return new TAppPhoenixHomepageItem({ suggestedAlbum });
    }
    public static fromSuggestedPhotos(suggestedPhotos: TAppPhoenixHomepagePhotosSuggestion): TAppPhoenixHomepageItem {
        return new TAppPhoenixHomepageItem({ suggestedPhotos });
    }
    public static fromAlbumShareSuggestion(albumShareSuggestion: TAppPhoenixHomepageAlbumShareSuggestion): TAppPhoenixHomepageItem {
        return new TAppPhoenixHomepageItem({ albumShareSuggestion });
    }
    public static fromAlbumFaceTagSuggestion(albumFaceTagSuggestion: TAppPhoenixHomepageAlbumFaceTagSuggestion): TAppPhoenixHomepageItem {
        return new TAppPhoenixHomepageItem({ albumFaceTagSuggestion });
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixHomepageItem");
        if (this.cluster != null) {
            output.writeFieldBegin("cluster", thrift.Thrift.Type.STRUCT, 1);
            this.cluster.write(output);
            output.writeFieldEnd();
        }
        if (this.album != null) {
            output.writeFieldBegin("album", thrift.Thrift.Type.STRUCT, 2);
            this.album.write(output);
            output.writeFieldEnd();
        }
        if (this.suggestedAlbum != null) {
            output.writeFieldBegin("suggestedAlbum", thrift.Thrift.Type.STRUCT, 3);
            this.suggestedAlbum.write(output);
            output.writeFieldEnd();
        }
        if (this.suggestedPhotos != null) {
            output.writeFieldBegin("suggestedPhotos", thrift.Thrift.Type.STRUCT, 4);
            this.suggestedPhotos.write(output);
            output.writeFieldEnd();
        }
        if (this.albumShareSuggestion != null) {
            output.writeFieldBegin("albumShareSuggestion", thrift.Thrift.Type.STRUCT, 5);
            this.albumShareSuggestion.write(output);
            output.writeFieldEnd();
        }
        if (this.albumFaceTagSuggestion != null) {
            output.writeFieldBegin("albumFaceTagSuggestion", thrift.Thrift.Type.STRUCT, 6);
            this.albumFaceTagSuggestion.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixHomepageItem {
        let _fieldsSet: number = 0;
        let _returnValue: TAppPhoenixHomepageItem | null = null;
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_368: TAppPhoenixHomepageCluster = TAppPhoenixHomepageCluster.read(input);
                        _returnValue = TAppPhoenixHomepageItem.fromCluster(value_368);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_369: TAppPhoenixHomepageAlbum = TAppPhoenixHomepageAlbum.read(input);
                        _returnValue = TAppPhoenixHomepageItem.fromAlbum(value_369);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_370: TAppPhoenixHomepageAlbumSuggestion = TAppPhoenixHomepageAlbumSuggestion.read(input);
                        _returnValue = TAppPhoenixHomepageItem.fromSuggestedAlbum(value_370);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_371: TAppPhoenixHomepagePhotosSuggestion = TAppPhoenixHomepagePhotosSuggestion.read(input);
                        _returnValue = TAppPhoenixHomepageItem.fromSuggestedPhotos(value_371);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_372: TAppPhoenixHomepageAlbumShareSuggestion = TAppPhoenixHomepageAlbumShareSuggestion.read(input);
                        _returnValue = TAppPhoenixHomepageItem.fromAlbumShareSuggestion(value_372);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_373: TAppPhoenixHomepageAlbumFaceTagSuggestion = TAppPhoenixHomepageAlbumFaceTagSuggestion.read(input);
                        _returnValue = TAppPhoenixHomepageItem.fromAlbumFaceTagSuggestion(value_373);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_fieldsSet > 1) {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with more than one set value!");
        }
        else if (_fieldsSet < 1) {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with no set value!");
        }
        if (_returnValue !== null) {
            return _returnValue;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read data for TUnion");
        }
    }
}
export interface ITAppPhoenixHomepageClusterUpdateTypeArgs {
    newPhoto?: TAppPhoenixPhotoMeta;
    newReaction?: TAppPhoenixReaction;
    newComment?: TAppPhoenixComment;
}
export class TAppPhoenixHomepageClusterUpdateType {
    public newPhoto?: TAppPhoenixPhotoMeta;
    public newReaction?: TAppPhoenixReaction;
    public newComment?: TAppPhoenixComment;
    constructor(args?: ITAppPhoenixHomepageClusterUpdateTypeArgs) {
        let _fieldsSet: number = 0;
        if (args != null) {
            if (args.newPhoto != null) {
                _fieldsSet++;
                this.newPhoto = args.newPhoto;
            }
            if (args.newReaction != null) {
                _fieldsSet++;
                this.newReaction = args.newReaction;
            }
            if (args.newComment != null) {
                _fieldsSet++;
                this.newComment = args.newComment;
            }
            if (_fieldsSet > 1) {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with more than one set value!");
            }
            else if (_fieldsSet < 1) {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with no set value!");
            }
        }
    }
    public static fromNewPhoto(newPhoto: TAppPhoenixPhotoMeta): TAppPhoenixHomepageClusterUpdateType {
        return new TAppPhoenixHomepageClusterUpdateType({ newPhoto });
    }
    public static fromNewReaction(newReaction: TAppPhoenixReaction): TAppPhoenixHomepageClusterUpdateType {
        return new TAppPhoenixHomepageClusterUpdateType({ newReaction });
    }
    public static fromNewComment(newComment: TAppPhoenixComment): TAppPhoenixHomepageClusterUpdateType {
        return new TAppPhoenixHomepageClusterUpdateType({ newComment });
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixHomepageClusterUpdateType");
        if (this.newPhoto != null) {
            output.writeFieldBegin("newPhoto", thrift.Thrift.Type.STRUCT, 1);
            this.newPhoto.write(output);
            output.writeFieldEnd();
        }
        if (this.newReaction != null) {
            output.writeFieldBegin("newReaction", thrift.Thrift.Type.STRUCT, 2);
            this.newReaction.write(output);
            output.writeFieldEnd();
        }
        if (this.newComment != null) {
            output.writeFieldBegin("newComment", thrift.Thrift.Type.STRUCT, 3);
            this.newComment.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixHomepageClusterUpdateType {
        let _fieldsSet: number = 0;
        let _returnValue: TAppPhoenixHomepageClusterUpdateType | null = null;
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_374: TAppPhoenixPhotoMeta = TAppPhoenixPhotoMeta.read(input);
                        _returnValue = TAppPhoenixHomepageClusterUpdateType.fromNewPhoto(value_374);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_375: TAppPhoenixReaction = TAppPhoenixReaction.read(input);
                        _returnValue = TAppPhoenixHomepageClusterUpdateType.fromNewReaction(value_375);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_376: TAppPhoenixComment = TAppPhoenixComment.read(input);
                        _returnValue = TAppPhoenixHomepageClusterUpdateType.fromNewComment(value_376);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_fieldsSet > 1) {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with more than one set value!");
        }
        else if (_fieldsSet < 1) {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with no set value!");
        }
        if (_returnValue !== null) {
            return _returnValue;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read data for TUnion");
        }
    }
}
export interface ITAppPhoenixNotificationPageItemArgs {
    reaction?: TAppPhoenixReactionNotification;
    comment?: TAppPhoenixCommentNotification;
    newAlbumMember?: TAppPhoenixAlbumMember;
    invite?: TAppPhoenixAlbumInvite;
}
export class TAppPhoenixNotificationPageItem {
    public reaction?: TAppPhoenixReactionNotification;
    public comment?: TAppPhoenixCommentNotification;
    public newAlbumMember?: TAppPhoenixAlbumMember;
    public invite?: TAppPhoenixAlbumInvite;
    constructor(args?: ITAppPhoenixNotificationPageItemArgs) {
        let _fieldsSet: number = 0;
        if (args != null) {
            if (args.reaction != null) {
                _fieldsSet++;
                this.reaction = args.reaction;
            }
            if (args.comment != null) {
                _fieldsSet++;
                this.comment = args.comment;
            }
            if (args.newAlbumMember != null) {
                _fieldsSet++;
                this.newAlbumMember = args.newAlbumMember;
            }
            if (args.invite != null) {
                _fieldsSet++;
                this.invite = args.invite;
            }
            if (_fieldsSet > 1) {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with more than one set value!");
            }
            else if (_fieldsSet < 1) {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with no set value!");
            }
        }
    }
    public static fromReaction(reaction: TAppPhoenixReactionNotification): TAppPhoenixNotificationPageItem {
        return new TAppPhoenixNotificationPageItem({ reaction });
    }
    public static fromComment(comment: TAppPhoenixCommentNotification): TAppPhoenixNotificationPageItem {
        return new TAppPhoenixNotificationPageItem({ comment });
    }
    public static fromNewAlbumMember(newAlbumMember: TAppPhoenixAlbumMember): TAppPhoenixNotificationPageItem {
        return new TAppPhoenixNotificationPageItem({ newAlbumMember });
    }
    public static fromInvite(invite: TAppPhoenixAlbumInvite): TAppPhoenixNotificationPageItem {
        return new TAppPhoenixNotificationPageItem({ invite });
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppPhoenixNotificationPageItem");
        if (this.reaction != null) {
            output.writeFieldBegin("reaction", thrift.Thrift.Type.STRUCT, 1);
            this.reaction.write(output);
            output.writeFieldEnd();
        }
        if (this.comment != null) {
            output.writeFieldBegin("comment", thrift.Thrift.Type.STRUCT, 2);
            this.comment.write(output);
            output.writeFieldEnd();
        }
        if (this.newAlbumMember != null) {
            output.writeFieldBegin("newAlbumMember", thrift.Thrift.Type.STRUCT, 3);
            this.newAlbumMember.write(output);
            output.writeFieldEnd();
        }
        if (this.invite != null) {
            output.writeFieldBegin("invite", thrift.Thrift.Type.STRUCT, 4);
            this.invite.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppPhoenixNotificationPageItem {
        let _fieldsSet: number = 0;
        let _returnValue: TAppPhoenixNotificationPageItem | null = null;
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_377: TAppPhoenixReactionNotification = TAppPhoenixReactionNotification.read(input);
                        _returnValue = TAppPhoenixNotificationPageItem.fromReaction(value_377);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_378: TAppPhoenixCommentNotification = TAppPhoenixCommentNotification.read(input);
                        _returnValue = TAppPhoenixNotificationPageItem.fromComment(value_378);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_379: TAppPhoenixAlbumMember = TAppPhoenixAlbumMember.read(input);
                        _returnValue = TAppPhoenixNotificationPageItem.fromNewAlbumMember(value_379);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_380: TAppPhoenixAlbumInvite = TAppPhoenixAlbumInvite.read(input);
                        _returnValue = TAppPhoenixNotificationPageItem.fromInvite(value_380);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_fieldsSet > 1) {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with more than one set value!");
        }
        else if (_fieldsSet < 1) {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with no set value!");
        }
        if (_returnValue !== null) {
            return _returnValue;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read data for TUnion");
        }
    }
}
